import { TranslationObject } from '@/types';

export const deMessages: TranslationObject = {
  maintenanceBanner: {
    dismiss: 'Ausblenden',
  },
  tipsNews: {
    panel: {
      title: 'Tipps & News',
      emptyState: 'Derzeit keine neuen Tipps.',
      dismiss: 'Verstanden',
      learnMore: 'Mehr erfahren',
      ariaLabel: 'Tipps & News',
    },
    tag: {
      new: 'Neu',
      tip: 'Tipp',
      info: 'Info',
      bestPractice: 'Best Practice',
    },
  },
  administration: {
    header: 'Verwaltung',
    usageAnalytics: {
      header: 'Nutzungsanalyse',
      description: 'Estimator-Nutzung innerhalb Ihres Mandanten im Zeitverlauf.',
      fromLabel: 'Von',
      toLabel: 'Bis',
      aggregationLabel: 'Aggregation',
      agg: {
        day: 'Tag',
        week: 'Woche',
        month: 'Monat',
        quarter: 'Quartal',
        year: 'Jahr',
      },
      aiAdvisor: 'AI Advisor',
      guidedMode: 'Geführter Modus',
      detailedMode: 'Detaillierter Modus',
      aiReview: 'AI Review',
      humanReview: 'Manuelle Prüfung',
      series: {
        uses: 'Nutzungen',
        started: 'Begonnen',
        completed: 'Abgeschlossen',
      },
      summaryStartedCompleted: '{started} begonnen · {completed} abgeschlossen',
      emptyState: 'Keine Nutzungsdaten für die gewählten Filter',
      exportLabel: 'CSV exportieren',
      coverage: {
        detailedMode:
          'Enthält Altschätzungen, die vor der Erfassung des geführten/detaillierten Modus erstellt wurden.',
        guidedMode:
          'Nur Schätzungen, die nach Einführung der Moduserfassung erstellt wurden, werden dem geführten Modus zugeordnet.',
        humanReview:
          'Nur Schätzungen, die nach Einführung der Prüfungserfassung geprüft wurden, werden gezählt.',
      },
    },
    tipsNews: {
      header: 'Tipps & News',
      description:
        'Veröffentlichen Sie Tipps-&-News-Einträge für die Benutzer Ihres Mandanten in deren ausgewählter Sprache.',
      createLabel: 'Neuer Eintrag',
      emptyState: 'Noch keine Tipps-&-News-Einträge. Erstellen Sie einen, um zu beginnen.',
      colTag: 'Kategorie',
      colTitle: 'Titel',
      colStatus: 'Status',
      colValidity: 'Gültigkeit',
      colActions: 'Aktionen',
      tagNew: 'Neu',
      tagTip: 'Tipp',
      tagInfo: 'Info',
      tagBestPractice: 'Best Practice',
      statusDraft: 'Entwurf',
      statusActive: 'Aktiv',
      statusScheduled: 'Geplant',
      statusExpired: 'Abgelaufen',
      formCreateTitle: 'Neuer Eintrag',
      formEditTitle: 'Eintrag bearbeiten',
      fieldTag: 'Kategorie',
      fieldTitleEn: 'Titel (Englisch)',
      fieldTitleDe: 'Titel (Deutsch)',
      fieldBodyEn: 'Text (Englisch)',
      fieldBodyDe: 'Text (Deutsch)',
      fieldCtaLabelEn: 'CTA-Beschriftung (Englisch)',
      fieldCtaLabelDe: 'CTA-Beschriftung (Deutsch)',
      fieldCtaUrl: 'CTA-URL',
      fieldValidFrom: 'Gültig ab',
      fieldValidUntil: 'Gültig bis',
      fieldStatus: 'Status',
      statusDraftOption: 'Entwurf (für Benutzer verborgen)',
      statusActiveOption: 'Aktiv (für Benutzer sichtbar)',
      languageWarning:
        'Eine Sprache ist leer. Sie können den Eintrag dennoch aktivieren - Benutzer mit dieser Sprache sehen die andere als Ausweichoption.',
      fallbackHint:
        'Jeder Benutzer sieht die Version für seine UI-Sprache; eine leere Sprache greift auf die andere zurück.',
      save: 'Speichern',
      cancel: 'Abbrechen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      deleteConfirm:
        'Diesen Tipps-&-News-Eintrag löschen? Dies kann nicht rückgängig gemacht werden.',
      saveSuccess: 'Tipps-&-News-Eintrag gespeichert.',
      saveError: 'Fehler beim Speichern des Tipps-&-News-Eintrags.',
      ctaUrlError: 'Die CTA-URL muss eine absolute http(s)-URL sein (z. B. https://example.com).',
      dateOrderError: '„Gültig ab" muss vor „Gültig bis" liegen.',
      activeNeedsContentError:
        'Ein aktiver Eintrag benötigt Titel und Text in mindestens einer Sprache.',
      deleteSuccess: 'Tipps-&-News-Eintrag gelöscht.',
      deleteError: 'Fehler beim Löschen des Tipps-&-News-Eintrags.',
      noTitle: '(ohne Titel)',
      none: '—',
    },
    tab: {
      usageAnalytics: {
        label: 'Nutzungsanalyse',
      },
      tipsNews: {
        label: 'Tipps & News',
      },
      tenantSettings: {
        label: 'Mandant',
        header: 'Mandanteneinstellungen',
        nameFieldLabel: 'Mandantenname',
        nameFieldPlaceholder: 'Geben Sie die Bezeichnung Ihres Mandanten ein.',
        descriptionFieldLabel: 'Beschreibung',
        descriptionFieldPlaceholder: 'Geben Sie eine Beschreibung ein.',
        darkModeLogoFieldLabel: 'Logo für den Dunkelmodus',
        logoFieldLabel: 'Logo',
        logoFieldPlaceholder: 'Datei auswählen...',
        iconFieldButton: 'Aktuelles Logo',
        languagesLabel: 'Sprachen',
        languagesLabelNotice: 'Mindestens eine Sprache muss ausgewählt werden.',
        defaultLanguageLabel: 'Standardsprache',
        defaultHighlightColorLabel: 'Hervorhebungsfarbe',
      },
      aiWizard: {
        label: 'AI Advisory',
        advisoryDefaultModelLabel: 'Standard-Schätzmodell',
        advisoryDefaultModelDescription:
          'Auf der Seite "In Schätzung umwandeln" vorausgewählt. Leer lassen, um das vorinstallierte KI-Beratungsmodell zu verwenden.',
        advisoryDefaultModelPlaceholder: 'Vorinstalliertes KI-Beratungsmodell verwenden',
        header: 'AI Advisory Einstellungen',
        aiFeaturesToggleLabel: 'AI Advisory aktivieren',
        aiFeaturesToggleDescription:
          'Aktivieren Sie die AI Advisory, um die AI Advisory Tab in der Seitenleiste anzuzeigen.',
        aiEnabled: 'Aktiviert',
        aiDisabled: 'Deaktiviert',
        aiInstructionsLabel: 'Mandantenanweisungen',
        aiInstructionsPlaceholder:
          'Geben Sie spezifische Anweisungen für den AI-Assistenten ein, der bei der Hilfe von Benutzern in diesem Mandanten helfen soll...',
        aiInstructionsDescription:
          'Geben Sie kontextbezogene Anweisungen ein, die den AI-Assistenten dabei helfen, Ihre Organisation besser zu verstehen.',
        promptIdLabel: 'Prompt ID',
        promptIdPlaceholder: 'Geben Sie die Prompt ID ein...',
        promptIdDescription:
          'Die eindeutige Kennung für die AI-Prompt-Vorlage. Leer lassen, um das Systemstandard zu verwenden.',
        promptVersionLabel: 'Prompt Version',
        promptVersionPlaceholder: 'Geben Sie die Prompt Version ein...',
        promptVersionDescription:
          'Die Version der Prompt-Vorlage. Leer lassen, um die neueste Version zu verwenden.',
        apiKeyLabel: 'API Key',
        apiKeyPlaceholder: 'Geben Sie Ihre API Key ein...',
        apiSaveDataSuccess: 'AI Advisory Einstellungen erfolgreich gespeichert',
        apiSaveDataError:
          'Fehler beim Speichern der AI Advisory Einstellungen. Bitte versuchen Sie es erneut.',
        apiKeyDescription:
          'Optional: Geben Sie eine benutzerdefinierte API Key für diesen Mandanten ein. Leer lassen, um das Systemstandard zu verwenden.',
        organizationIdLabel: 'Organisations-ID',
        organizationIdPlaceholder: 'Geben Sie Ihre OpenAI Organisations-ID ein...',
        organizationIdDescription:
          'Optional: Geben Sie eine benutzerdefinierte Organisations-ID für diesen Mandanten ein. Leer lassen, um das Systemstandard zu verwenden.',
        projectIdLabel: 'Projekt-ID',
        projectIdPlaceholder: 'Geben Sie Ihre OpenAI Projekt-ID ein...',
        projectIdDescription:
          'Optional: Geben Sie eine benutzerdefinierte Projekt-ID für diesen Mandanten ein. Leer lassen, um das Systemstandard zu verwenden.',
        testConnectionButton: 'Verbindung testen',
        testConnectionSuccess:
          'Verbindungstest erfolgreich! Die AI-Konfiguration funktioniert korrekt.',
        testConnectionError:
          'Verbindungstest fehlgeschlagen. Bitte überprüfen Sie Ihre Konfiguration.',
        testConnectionTesting: 'Verbindung wird getestet...',
      },
      aiAdvisoryTabs: {
        settings: 'Einstellungen',
        tenantContext: 'Mandantenkontext',
      },
      tenantContext: {
        header: 'Mandantenkontext',
        completeness: '{configured} / {total} Abschnitte konfiguriert',
        saveTenantContext: 'Mandantenkontext speichern',
        saveSuccess: 'Mandantenkontext wurde erfolgreich gespeichert.',
        saveError: 'Mandantenkontext konnte nicht gespeichert werden. Bitte erneut versuchen.',
        section1: 'Mandantenidentität',
        section2: 'Geografie & Standorte',
        section3: 'Regulatorisches & rechtliches Umfeld',
        section4: 'Technologie & Architekturstandards',
        section5: 'Organisationsstruktur & Arbeitsweisen',
        section6: 'Sicherheitslage & Zugriff',
        section7: 'Nicht-funktionale Standards',
        section8: 'Ressourcenkosten',
        section9: 'Risikobereitschaft & Änderungskultur',
        section10: 'Pflichtliefergegenstände des Kunden',
        s1FieldName: 'Name',
        s1FieldIndustry: 'Branche / Sektor',
        s1FieldSubIndustry: 'Teilbranche / Geschäftsbereich',
        s1FieldCompanySize: 'Unternehmensgröße',
        s2FieldCountries: 'Länder / Betriebsregionen',
        s2FieldPrimaryRegions: 'Primäre Regionen',
        s2FieldLanguages: 'Sprachen',
        s2FieldTimeZones: 'Zeitzonen',
        s3FieldRegulations: 'Anwendbare Vorschriften',
        s3FieldDataSensitivity: 'Datensensitivität',
        s3FieldCompliancePosture: 'Compliance-Haltung',
        s4FieldHostingModel: 'Hosting-Modell',
        s4FieldCloudProviders: 'Cloud-Anbieter',
        s4FieldTechStack: 'Tech-Stack',
        s4FieldIntegrationPatterns: 'Integrationsmuster',
        s4FieldDatabases: 'Datenbanken',
        s4FieldDevOpsTooling: 'DevOps-Tools',
        s5FieldDeliveryModel: 'Liefermodell',
        s5FieldMethodologies: 'Methoden',
        s5FieldWaysOfWorking: 'Arbeitsweisen',
        s6FieldSecurityLevel: 'Sicherheitsstufe',
        s6FieldIdentityStandards: 'Identitätsstandards',
        s6FieldDataClassification: 'Datenklassifizierung',
        s6FieldSecurityReview: 'Erwartungen an Sicherheitsüberprüfungen',
        s7FieldAvailability: 'Verfügbarkeitsziel',
        s7FieldPerformance: 'Leistungserwartungen',
        s7FieldSupportHours: 'Support-Zeiten',
        s7FieldEnvironments: 'Umgebungen',
        s7FieldDocumentation: 'Dokumentationserwartungen',
        s8FieldDayRates: 'Tagessätze nach Ressourcenkategorie',
        s9FieldRiskAppetite: 'Risikobereitschaft',
        s9FieldChangeManagement: 'Strenge des Change-Managements',
        s9FieldOversightStyle: 'Stil der Projektaufsicht',
        s10FieldDeliverables: 'Pflichtliefergegenstände (Liste)',
      },
      exportSettings: {
        label: 'Exporteinstellungen',
        header: 'Exporteinstellungen',
        exportSettingsTitle: 'Export-Formatierung',
        exportSettingsDescription:
          'Passen Sie das Erscheinungsbild von PDF- und Excel-Exporten an. Diese Einstellungen werden auf beide Exportformate angewendet.',
        tableHeadersLabel: 'Tabellenüberschriften',
        tableRowsLabel: 'Tabellenzeilen',
        tableSummaryLabel: 'Tabellenzusammenfassung',
        fontColorLabel: 'Schriftfarbe',
        backgroundColorLabel: 'Hintergrundfarbe',
        fontFamilyLabel: 'Schriftart',
        boldLabel: 'Fett',
        italicLabel: 'Kursiv',
        fontFamilyRoboto: 'Roboto',
        fontFamilyArial: 'Arial',
        fontFamilyTimes: 'Times New Roman',
        fontFamilyCourier: 'Courier New',
        fontFamilyHelvetica: 'Helvetica',
        apiSaveDataSuccess: 'Exporteinstellungen erfolgreich gespeichert',
        apiSaveDataError:
          'Fehler beim Speichern der Exporteinstellungen. Bitte versuchen Sie es erneut.',
        apiLoadDataError:
          'Fehler beim Laden der Exporteinstellungen. Bitte versuchen Sie es erneut.',
      },
      individualisation: {
        label: 'Anpassung',
        header: 'Anpassung von Bezeichnungen',
        table: {
          column: {
            label: {
              originalValue: 'Ursprüngliche Bezeichnung',
              location: 'Ort',
              customized: 'Benutzerdefinierte Zeichenfolge',
            },
          },
        },
        successfullySaved: 'Benutzerdefinierte Zeichenfolge erfolgreich gespeichert',
        unexpectedErrorDuringSave: 'Unerwarteter Fehler beim Speichern',
      },
      projectTypes: {
        label: 'Projekttypen',
        header: 'Projekttypen verwalten',
        createNew: 'Neuen Projekttyp erstellen',
        projectTypeEditComponentTitle: 'Projekttyp: {name}',
        nameFieldLabel: 'Name:',
        nameFieldPlaceholder: 'Bezeichnung des Projekttyps',
        descriptionFieldLabel: 'Beschreibung:',
        descriptionFieldPlaceholder: 'Geben Sie eine Beschreibung ein.',
        iconFieldLabel: 'Symbol:',
        iconFieldButton: 'Symbol auswählen',
        apiLoadDataError: 'Daten können nicht vom Server geladen werden.',
        apiSaveDataError: 'Unerwarteter Fehler beim Speichern der Daten.',
        fileReadError: 'Datei konnte nicht gelesen werden.',
        apiSaveDataSuccess: 'Mandanteneinstellungen erfolgreich gespeichert',
        failedToUploadTenantLogos:
          'Das Hochladen der Tenant-Logos ist fehlgeschlagen.<br>Es werden nur die folgenden Formate unterstützt: {formats}, die maximale Größe beträgt {size}MB.',
        apiSaveDataSuccessful: 'Projekttypen erfolgreich gespeichert',
        requiredFieldLabel: 'Dieses Feld ist erforderlich',
      },
      methodologies: {
        label: 'Methoden',
        header: 'Methoden verwalten',
        createNew: 'Neue Methode erstellen',
        methodologyEditComponentTitle: 'Methode: {name}',
        nameFieldLabel: 'Name:',
        nameFieldPlaceholder: 'Name der Methode',
        descriptionFieldLabel: 'Beschreibung:',
        descriptionFieldPlaceholder: 'Geben Sie eine Beschreibung ein.',
        fieldsLabel: 'Felder:',
        formulaFieldLabel: 'Formel:',
        formulaFieldPlaceholder: 'Geben Sie die Berechnungsformel ein.',
        apiLoadDataError: 'Daten können nicht vom Server geladen werden.',
        apiSaveDataError: 'Unerwarteter Fehler beim Speichern der Daten.',
        apiSaveDataSuccessful: 'Methoden erfolgreich gespeichert',
        requiredFieldLabel: 'Dieses Feld ist erforderlich.',
        atLeastOneParameterRequired: 'Mindestens ein Parameter ist erforderlich.',
        formulaHelpText:
          'Verwenden Sie arithmetische Operatoren (+, -, *, /, %), Klammern, param[parameterName]',
        formulaValidationError: 'Ungültige Formel-Syntax',
      },
      models: {
        apiLoadDataError: 'Daten können nicht vom Server geladen werden.',
        apiSaveDataError: 'Unerwarteter Fehler beim Speichern der Daten.',
        publishConfirmationTitle: 'Freigeben bestätigen',
        publishConfirmationDesc:
          'Möchten Sie das Schätzmodell freigeben? Alle Änderungen werden übernommen und das Modell wird in neuen Projekten verwendet.',
        publishConfirmationCompletedTitle: 'Schätzmodell freigegeben',
        publishConfirmationCompletedDesc:
          'Das Schätzmodell wurde freigegeben und jedes neue Projekt wird diese neue Konfiguration verwenden.',
        estimationModelNameTitle: 'Schätzmodell',
        archiveLabel: 'Archivieren',
        reactivateLabel: 'Reaktivieren',
        archiveConfirmationTitle: 'Schätzmodell archivieren',
        archiveConfirmationModelName: 'Modell: {name}',
        archiveConfirmationAffectedEstimations:
          '{count, plural, one {# bestehende Schätzung verwendet dieses Modell.} other {# bestehende Schätzungen verwenden dieses Modell.}}',
        archiveConsequenceEstimationsKeepWorking:
          'Bestehende Schätzungen bleiben vollständig funktionsfähig.',
        archiveConsequenceBanner:
          'Bestehende Schätzungen zeigen einen Hinweis "archiviertes Modell" an.',
        archiveConsequenceNoNewEstimations:
          'Neue Schätzungen können dieses Modell nicht auswählen.',
        archiveConsequenceReversible: 'Sie können das Modell jederzeit wieder reaktivieren.',
        reactivateConfirmationTitle: 'Schätzmodell reaktivieren',
        reactivateConfirmationDesc:
          'Dieses Modell kann wieder für neue Schätzungen ausgewählt werden. Der Hinweis auf das archivierte Modell wird in allen bestehenden Schätzungen entfernt.',
        archivedSuccessfully: 'Schätzmodell archiviert',
        reactivatedSuccessfully: 'Schätzmodell reaktiviert',
      },
      estimationModels: {
        general: {
          fieldEstimationModelNameLabel: 'Modellname des Projekttyps',
          fieldEstimationModelNamePlaceholder: 'Geben Sie den Modellnamen ein.',
          fieldDescriptionLabel: 'Beschreibung (Nur für den Administrator)',
          fieldDescriptionPlaceholder: 'Geben Sie eine Beschreibung ein.',
          fieldProjectTypeLabel: 'Projekttyp',
          fieldEstimationUnitsLabel: 'Schätzeinheiten',
          versionLabel: 'Schätzmodell-Version',
          atLeastOneEstimationUnitShouldBeSelectedError:
            'Mindestens eine Schätzeinheit sollte ausgewählt werden.',
        },
      },
      estimationMethodologies: {
        label: 'Methoden',
      },
      estimationModelsDetail: {
        label: 'Modelle',
        header: 'Ihre Schätzmodelle',
        createNew: 'Neues Modell erstellen',
        nameFieldLabel: 'Modellname',
        nameFieldPlaceholder: 'Aktive Version',
        descriptionFieldLabel: 'Arbeitsversion:',
        descriptionFieldPlaceholder: 'Projekttyp',
        iconFieldLabel: 'Autor',
        showArchivedModels: 'Archivierte Modelle anzeigen',
        archivedBadge: 'Archiviert',
      },
      users: {
        label: 'Benutzer',
        header: 'Benutzer verwalten',
        tableTitleName: 'Vorname',
        tableTitleSurname: 'Nachname',
        tableTitleRole: 'Rolle',
        tableTitleEmail: 'E-Mail',
        tableTitleStatus: 'Status',
        userStatusActive: 'Aktiv',
        userStatusInactive: 'Inaktiv',
        setupFederatedUserManagement: 'Externe Benutzerverwaltung einrichten',
        addNewUserButton: 'Benutzer hinzufügen',
        addNewUserModalTitle: 'Benutzer hinzufügen',
        editUserModalTitle: 'Benutzer bearbeiten',
        federatedIdentityModalTitle: 'Externe Identität einrichten',
        userFormFirstnameLabel: 'Vorname',
        userFormFirstnamePlaceholder: 'Geben Sie den Vornamen ein.',
        userFormLastnameLabel: 'Nachname',
        userFormLastnamePlaceholder: 'Geben Sie den Nachnamen ein.',
        userFormEmailLabel: 'E-Mail',
        userFormEmailPlaceholder: 'Geben Sie die E-Mail ein.',
        userFormRoleLabel: 'Rolle',
        userFormLanguage: 'Sprache',
        saveUserPassword: 'Speichern Sie dieses Passwort, es wird später nicht mehr verfügbar sein',
        deleteUserTitle: 'Benutzer löschen',
        deleteUserConfirmationText:
          'Sind Sie sicher, dass Sie den Benutzer "{userEmail}" löschen möchten?',
        userDeletedConfirmationTitle: 'Bestätigung',
        userDeletedConfirmationText: 'Der Benutzer wurde gelöscht.',
        copyUserPassword: 'Benutzerpasswort kopieren',
        userPassword: 'Benutzerpasswort',
        userFormStatusLabel: 'Status (aktiv/inaktiv)',
        disableUserTitle: 'Benutzer deaktivieren',
        disableUserConfirmationText:
          'Sind Sie sicher, dass Sie den Benutzer deaktivieren möchten "{userEmail}"?',
        userDisabledConfirmationTitle: 'Bestätigung',
        userDisabledConfirmationText: 'Der Benutzer wurde deaktiviert.',
      },
      workflow: {
        label: 'Workflow',
        header: 'Workflowschritte verwalten',
        nameFieldLabel: 'Name:',
        nameFieldPlaceholder: 'Name des Workflowschritts',
        summaryFieldLabel: 'Zusammenfassung:',
        summaryFieldPlaceholder: 'Zusammenfassung des Workflows eingeben',
        descriptionFieldLabel: 'Beschreibung:',
        descriptionFieldPlaceholder: 'Beschreibung eingeben',
        urlFieldLabel: 'URL:',
        urlFieldPlaceholder: 'Externe URL eingeben',
        apiLoadDataError: 'Daten können nicht vom Server geladen werden',
        apiSaveDataSuccessful: 'Workflow-Schritte erfolgreich gespeichert',
        apiSaveDataError: 'Unerwarteter Fehler beim Speichern der Workflow-Schritte',
      },
      notificationSettings: {
        label: 'Benachrichtigungseinstellungen',
      },
      notificationTemplates: {
        variablePhaseResponsibleFirstName: 'Vorname des Phasenverantwortlichen',
        variablePhaseResponsibleLastName: 'Nachname des Phasenverantwortlichen',
        variablePhaseResponsibleEmail: 'E-Mail des Phasenverantwortlichen',
        variablePhaseStatus: 'Phasenstatus',
        variablePhaseStatusPrevious: 'Vorheriger Phasenstatus',
        variablePhaseDeadline: 'Phasen-Fälligkeitsdatum',
        label: 'Benachrichtigungsvorlagen',
        header: 'Benachrichtigungsvorlagen',
        eventLabel: 'Workflow-Ereignis',
        languageLabel: 'Sprache',
        subjectLabel: 'E-Mail-Betreff',
        bodyLabel: 'Nachrichtentext',
        variablesLabel: 'Variable einfügen',
        apiLoadError:
          'Benachrichtigungsvorlage konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        apiSaveSuccess: 'Benachrichtigungsvorlage erfolgreich gespeichert.',
        apiSaveError:
          'Speichern der Benachrichtigungsvorlage fehlgeschlagen. Bitte versuchen Sie es erneut.',
        apiResetSuccess: 'Vorlage wurde erfolgreich auf die Standardeinstellung zurückgesetzt.',
        apiResetError:
          'Zurücksetzen der Benachrichtigungsvorlage fehlgeschlagen. Bitte versuchen Sie es erneut.',
        resetButton: 'Auf Standardvorlage zurücksetzen',
        variableProjectName: 'Projektname',
        variableVersionName: 'Versionsname',
        variablePhaseName: 'Phasenname',
        variableAssignedBy: 'Zugewiesen von',
        variableDueDate: 'Fälligkeitsdatum',
        variableEstimationOwnerFirstName: 'Vorname des Schätzungseigentümers',
        variableEstimationOwnerLastName: 'Nachname des Schätzungseigentümers',
        variableEstimationOwnerEmail: 'E-Mail des Schätzungseigentümers',
        variableProjectResponsibleFirstName: 'Vorname des Projektverantwortlichen',
        variableProjectResponsibleLastName: 'Nachname des Projektverantwortlichen',
        variableProjectResponsibleEmail: 'E-Mail des Projektverantwortlichen',
        variableReviewOutcome: 'Überprüfungsergebnis',
        variableReviewerName: 'Name des Prüfers',
        variableReviewCompletedDate: 'Datum der Überprüfung',
        variableEstimationLink: 'Link zur Schätzung',
        previewInAppButton: 'In-App-Vorschau',
        previewEmailButton: 'E-Mail-Vorschau',
        previewTitle: 'E-Mail-Vorschau',
        previewInAppTitle: 'In-App-Vorschau',
        previewBanner: 'Vorschau mit Beispieldaten',
        previewFormatHtml: 'HTML',
        previewFormatText: 'Nur Text',
        previewLoading: 'Vorschau wird erstellt…',
        previewError: 'Vorschau konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
        statusOverridden:
          'Es wird eine mandantenspezifische Vorlage für dieses Ereignis und diese Sprache verwendet.',
        statusDefault:
          'Es wird die Systemstandardvorlage für dieses Ereignis und diese Sprache verwendet.',
        sendTestLabel: 'Test-E-Mail senden an',
        sendTestPlaceholder: 'name@example.com',
        sendTestButton: 'Test-E-Mail senden',
        sendTestInvalidEmail: 'Geben Sie eine gültige E-Mail-Adresse ein.',
        sendTestSuccess: 'Test-E-Mail gesendet.',
        sendTestError: 'Senden der Test-E-Mail fehlgeschlagen. Bitte versuchen Sie es erneut.',
      },
      notifications: {
        label: 'Benachrichtigungen',
      },
      generalSettings: {
        label: 'Allgemeine Einstellungen',
      },
      metadata: {
        label: 'Stammdaten',
      },
      assumptions: {
        label: 'Annahmen',
      },
      estimationGroups: {
        label: 'Schätzgruppen',
      },
      estimationTemplate: {
        label: 'Schätzvorlage',
      },
      resourceTypes: {
        label: 'Ressourcentypen',
      },
      costTypes: {
        label: 'Kostentypen',
      },
      ai: {
        label: 'AI',
      },
    },
    estimationModel: {
      assumptions: {
        assumptionEditComponentTitle: 'Annahme: {name}',
        nameFieldLabel: 'Name',
        nameFieldPlaceholder: 'Geben Sie die Bezeichnung der Annahme ein.',
        descriptionFieldLabel: 'Beschreibung (wird als Tooltip verwendet)',
        descriptionFieldPlaceholder: 'Geben Sie eine Beschreibung ein.',
        addNewButton: 'Annahme hinzufügen',
        title: 'Annahmetypen',
      },
      costTypes: {
        currenciesHeader: 'Währungen verwalten',
        addCurrency: 'Währung hinzufügen',
        costTypesHeader: 'Kostentypen verwalten',
        addCostType: 'Kostentyp hinzufügen',
        costTypeComponentTitle: 'Kostentyp: {name}',
        nameFieldLabel: 'Name',
        nameFieldPlaceholder: 'Geben Sie die Bezeichnung des Kostentyps ein.',
        descriptionFieldLabel: 'Beschreibung (wird als Tooltip verwendet)',
        descriptionFieldPlaceholder: 'Geben Sie eine Beschreibung ein.',
        addNewButton: 'Kostentyp hinzufügen',
        currencyNameHeader: 'Währungsname',
        currencyFieldPlaceholder: 'Währung auswählen',
        cannotDeleteCostTypeUsedByResourceTypeWarning:
          '{costTypeName}" wird in einem Ressourcentyp referenziert und kann nicht gelöscht werden. Bitte entfernen Sie zuerst alle Referenzen auf "{costTypeName}" im Ressourcentypen-Tab.',
        addCostTypeGroup: 'Kostengruppe hinzufügen',
        costTypeGroupComponentTitle: 'Kostengruppe: {name}',
        costTypeGroupComponentNameFieldLabel: 'Gruppenname',
        costTypesSectionTitle: 'Kostentypen',
        dropZonePlaceholder: 'Kostentypen hier ablegen',
        dropZonePlaceholderNote: 'oder neue über den obenstehenden Button erstellen',
        noCostTypesCreated: 'Keine Kostentypen erstellt',
      },
      estimationGroups: {
        groupsComponentTitle: 'Gruppe: {name}',
        nameFieldLabel: 'Name',
        nameFieldPlaceholder: 'Geben Sie die Bezeichnung der Schätzgruppe ein.',
        descriptionFieldLabel: 'Beschreibung (wird als Tooltip verwendet)',
        descriptionFieldPlaceholder: 'Geben Sie eine Beschreibung ein.',
        addNewButton: 'Schätzgruppe hinzufügen',
        title: 'Schätzgruppen',
        forbidCustomEstimationItemFieldLabel:
          'Hinzufügen eines benutzerdefinierten Schätzelements verbieten.',
      },
      template: {
        title: 'Schätzstruktur',
        addNewButton: 'Schätzobjekt hinzufügen',
        noItemsYet: 'Dieses Modell enthält noch keine Schätzobjekte.',
        itemsFailedToLoad:
          'Dieses Modell enthält auf dem Server {count} Schätzobjekte, von denen keines in den Editor geladen werden konnte. Bitte laden Sie die Seite neu und speichern Sie nicht: Beim Speichern gehen die {count} Schätzobjekte verloren, und der Vorgang kann nicht rückgängig gemacht werden.',
        removeParentButton: 'Übergeordnetes Element entfernen',
        removeParentConfirmationText:
          'Dieses Element wird auf die oberste Ebene verschoben. Seine Unterelemente werden mitverschoben.',
        removeParentCompletedTitle: 'Übergeordnetes Element entfernt',
        tableTitlePhaseName: 'Phasenname',
        editationModalTitle: 'Schätzobjekt',
        estimationGroupFieldLabel: 'Schätzgruppe',
        parentFieldLabel: 'Übergeordnetes Element',
        nameFieldLabel: 'Name',
        nameFieldPlaceholder: 'Name',
        referenceFieldLabel: 'Referenzname',
        referenceFieldPlaceholder: 'Referenz',
        descriptionFieldLabel: 'Beschreibung',
        descriptionFieldPlaceholder: 'Geben Sie die Beschreibung des Elements ein.',
        requiredFieldLabel: 'Dieses Feld ist erforderlich',
        estimationTypeFieldLabel: 'Schätztyp',
        estimationTypeUserModifiable: 'Vom Benutzer änderbar',
        estimationTypeParameterized: 'Aus Parametern berechnet',
        estimationTypeCalculated: 'Berechnet',
        fieldsFieldLabel: 'Felder',
        formulaFieldLabel: 'Formel',
        formulaFieldPlaceholder: 'Berechnungsformel eingeben',
        cancelButtonText: 'Abbrechen',
        saveButtonText: 'Speichern',
        columnHeaderOrder: '#',
        columnHeaderName: 'Name',
        resourcesTitle: 'Ressourcen',
        costsTitle: 'Kosten',
        whenThereAreNoParamsAndFormulaIsProvidedItemShouldBeCalculatedError:
          'Wenn keine Parameter vorhanden sind und eine Formel angegeben ist, sollte das Element berechnet werden.',
        whenFormulaIsProvidedAtLeastOneParameterMustExistError:
          'Wenn eine Formel angegeben wird, muss mindestens ein Parameter vorhanden sein.',
        formulaMustBeEmptyWhenUserModifiableError:
          'Beim Schätztyp „Vom Benutzer änderbar“ darf keine Formel festgelegt werden.',
        formulaRequiredForCalculatedTypeError:
          'Für berechnete Schätztypen ist eine Formel erforderlich.',
        wrongFormat: 'Falsches Format.',
        formulaHelpText:
          'Verwenden Sie arithmetische Operatoren (+, -, *, /, %), Klammern, param[parameterName], item[itemReference] und Funktionen wie sumItemsExcept(...) zum Berechnen des Werts. Beispiel: param[A] + param[B] + item[itemReference1] + sumItemsExcept(itemReference2, itemReference3)',
      },
      metadata: {
        metadataComponentTitle: 'Stammdaten: {name}',
        nameFieldLabel: 'Name',
        nameFieldPlaceholder: 'Geben Sie den Stammdatennamen ein.',
        descriptionFieldLabel: 'Beschreibung (wird als Tooltip verwendet)',
        descriptionFieldPlaceholder: 'Geben Sie eine Beschreibung ein.',
        guidedModeQuestionFieldLabel: 'Frage geführter Modus',
        guidedModeQuestionFieldPlaceholder: 'Frage für den geführten Modus eingeben.',
        typeFieldLabel: 'Stammdatentyp',
        typeFieldPlaceholder: 'Wählen Sie den Stammdatentyp aus.',
        mandatoryFieldLabel: 'Verpflichtend',
        addNewButton: 'Stammdaten hinzufügen',
        title: 'Stammdatentypen',
        selectOptionsFieldLabel: 'Auswählbare Optionen',
        selectOptionsFieldPlaceholder: 'Geben Sie jede Option in einer separaten Zeile ein.',
        emptyLinesNotAllowed: 'Leere Linien sind nicht erlaubt.',
        pipeNotAllowed: 'Pipe character is not allowed.',
      },
      methodologies: {
        title: 'Methoden auswählen',
        manageAllMethodologies: 'Alle Methoden verwalten',
      },
      resourceTypes: {
        resourceTypeEditComponentTitle: 'Ressourcentyp: {name}',
        nameFieldLabel: 'Name',
        nameFieldPlaceholder: 'Geben Sie den Namen des Ressourcentyps ein.',
        descriptionFieldLabel: 'Beschreibung (wird als Tooltip verwendet)',
        descriptionFieldPlaceholder: 'Geben Sie eine Beschreibung ein.',
        addNewButton: 'Ressourcentyp hinzufügen',
        costTypeFieldLabel: 'Kostentyp',
        costTypeFieldPlaceholder: 'Kostentyp des Ressourcentyps auswählen',
        title: 'Ressourcentypen',
        resourceCostFieldLabel: 'Ressourcenkosten',
        resourceCostUserModifiable: 'Vom Benutzer änderbar',
        addResourceGroup: 'Ressourcengruppe hinzufügen',
        resourceGroupComponentTitle: 'Ressourcengruppe: {name}',
        resourceGroupComponentNameFieldLabel: 'Gruppenname',
        resourceTypesSectionTitle: 'Ressourcentypen',
        addResourceType: 'Ressourcentyp hinzufügen',
        dropZonePlaceholder: 'Ressourcentypen hier ablegen',
        dropZonePlaceholderNote: 'oder neue über den obenstehenden Button erstellen',
        noResourceTypesCreated: 'Keine Ressourcentypen erstellt',
      },
      ai: {
        title: 'AI',
        subTitle: 'AI-Einstellungen verwalten',
        explanationTitle: 'Erklärung',
        explanationNumberOfWords:
          'ersetzt durch die maximale Anzahl der gewünschten Wörter in der Bewertung (bereitgestellt als Parameter durch den Endbenutzer bei der Anforderung der AI-Bewertung).',
        explanationAllPlaceholdersRequiredNote:
          'Bitte beachten Sie, dass alle Platzhalter erforderlich sind.',
        allPlaceholdersRequiredError:
          'Alle Platzhalter sind für das AI-Antwortformat erforderlich.',
        aiRequestTemplateFieldLabel: 'AI-Anforderungsformat',
        aiRequestTemplateFieldPlaceholder:
          'Stellen Sie formatierten Text für die AI-Anfrage bereit.',
        aiRequestTemplateFieldExampleTitle:
          'Beispiel (doppelklicken Sie auf den Beispieltext, um ihn zu verwenden).',
        aiRequestTemplateFieldExampleText:
          'Generieren Sie eine Zusammenfassung für das Management (mit einer Zusammenfassung des Projekts, Beobachtungen, Tipps zur Verbesserung der Aufwandschätzung und Schlüsselergebnissen) in {NUMBER_OF_WORDS} Wörtern in {LANGUAGE} Sprache für dieses Schätz-JSON: `{ESTIMATION_JSON}`',
        aiRequestTemplateFieldMaxLengthError:
          'Das AI-Anforderungsformat ist zu lang (es sind maximal {maxLength} Zeichen erlaub).',
        explanationLanguage: 'replaced with estimation language.',
        explanationEstimationJson: 'replaced with estimation JSON.',
        explanationProjectDescription:
          'automatisch in der JSON-Struktur innerhalb von {ESTIMATION_JSON} enthalten. Dieser Text liefert dem KI-Modul den Projektkontext für eine präzisere Rückmeldung.',
        projectDescriptionHelperText:
          'Dieser Text liefert dem KI-Modul den Projektkontext für eine präzisere Rückmeldung.',
        projectDescriptionJsonExample:
          'Der Platzhalter {ESTIMATION_JSON} wird durch ein JSON-Objekt ersetzt, das Schätzungsdaten enthält, einschließlich des Felds "projectDescription". Beispielstruktur: {"modelName": "...", "projectName": "...", "projectDescription": "...", "phases": [...], "items": [...]}',
        aiEnabledLabel: 'AI für dieses Modell aktivieren',
      },
    },
    estimationItemParameter: {
      table: {
        header: {
          order: '#',
          label: 'Bezeichnung',
          parameter: 'Parameter',
          defaultValue: 'Standardwert',
        },
      },
      addFieldButton: 'Feld hinzufügen',
      wrongFormat: 'Falsches Format.',
    },
  },
  validationErrorMessages: {
    title: 'Schätzstruktur',
    formulaValidation: {
      consecutiveBrackets:
        'Ungültige Syntax: aufeinanderfolgende Klammern "][" sind nicht erlaubt. Verwenden Sie Operatoren zwischen Referenzen (z.B. param[A] + param[B])',
      unmatchedBrackets:
        'Ungültige Syntax: nicht übereinstimmende oder verschachtelte Klammern. Verwenden Sie {allowedRefs}',
      invalidCharacters: 'Ungültige Zeichen gefunden: {invalidChars}',
      invalidParameterName:
        'Ungültiger Parametername: {paramName}. Nur alphanumerische Zeichen, Unterstriche und Bindestriche sind erlaubt.',
      parameterNotDefined:
        "Parameter '{paramName}' ist nicht definiert. Verfügbare Parameter: {availableParams}",
      parametersNotAllowed:
        'Parameter-Referenzen (param[...]) sind in diesem Kontext nicht erlaubt',
      invalidItemReference:
        'Ungültige Element-Referenz: {itemName}. Nur alphanumerische Zeichen, Unterstriche und Bindestriche sind erlaubt.',
      itemsNotAllowed: 'Element-Referenzen (item[...]) sind in diesem Kontext nicht erlaubt',
      invalidFunctionArgument:
        'Ungültiges Funktionsargument: {arg}. Nur alphanumerische Zeichen, Unterstriche und Bindestriche sind erlaubt.',
      functionsNotAllowed:
        'Funktions-Referenzen (sumItemsExcept(...)) sind in diesem Kontext nicht erlaubt',
      unbalancedParentheses: 'Nicht ausgeglichene Klammern in der Formel',
      emptyParentheses: 'Leere Klammern sind nicht erlaubt',
      divisionByZero: 'Formel enthält Division durch Null',
      consecutiveOperators: 'Aufeinanderfolgende Operatoren sind nicht erlaubt',
      operatorAtStart: 'Formel kann nicht mit +, *, / oder % Operatoren beginnen',
      operatorAtEnd: 'Formel kann nicht mit einem Operator enden',
      validationFailed: 'Formel-Validierung fehlgeschlagen: {errors}',
      incompleteParameter: 'Parametername fehlt. Verwenden Sie param[parameterName]',
      incompleteItem: 'Element-Referenz fehlt. Verwenden Sie item[itemReference]',
    },
  },
  sidebar: {
    dashboard: 'Übersicht',
    estimation: 'Schätzungen',
    aiAdvisory: 'AI Advisory',
    newEstimation: 'Neue Schätzung erstellen',
    wizardMode: 'Schätzassistent',
    newConversation: 'Neue Unterhaltung',
    detailedEstimation: 'Detaillierte Schätzung',
    notification: 'Benachrichtigungen',
    administration: 'Verwaltung',
    signOut: 'Abmelden',
  },
  convertAdvisory: {
    pageTitle: 'KI-Beratung in Schätzung umwandeln',
    pageSubtitle:
      'Wählen Sie die zu übernehmenden Phasen und Annahmen aus und bestätigen Sie anschließend die Projektstammdaten. Es wird ein neuer Schätzungsentwurf erstellt.',
    loadAdvisoryError:
      'Der Arbeitsumfang konnte aus dieser KI-Beratungsantwort nicht gelesen werden. Die Konversation selbst ist davon nicht betroffen.',
    extractionUnavailableError:
      'Die KI hat das Lesen des Arbeitsumfangs aus dieser Beratung nicht abgeschlossen. Ein erneuter Versuch ist meist erfolgreich.',
    partialImportNotice:
      '{imported} von {selected} ausgewählten Arbeitspaketen wurden übernommen. Die Beratungsstruktur hat sich zwischenzeitlich geändert, die übrigen konnten nicht mehr zugeordnet werden.',
    emptyStructureHint:
      'Sie können den Entwurf unten dennoch aus den Projektstammdaten erstellen und Phasen anschließend in der Schätzung ergänzen. Eine beantwortete Beratung kann nicht fortgeführt werden - starten Sie für eine Struktur vom Assistenten eine neue Beratung mit mehr Details.',
    noStructuredData:
      'Diese Beratungsantwort enthält keine Arbeitsstruktur, die übernommen werden kann.',
    askAgainButton: 'Erneut in einer neuen Beratung fragen',
    selectionHeading: 'Was übernommen wird',
    wbsSectionTitle: 'Projektstrukturplan ({count})',
    assumptionsSectionTitle: 'Annahmen ({count})',
    selectAll: 'Alle auswählen',
    selectNone: 'Keine auswählen',
    masterDataHeading: 'Projektstammdaten',
    projectTypeLabel: 'Projekttyp',
    projectTypeUnavailableSuffix: 'nicht verfügbar: {reason}',
    requirementNoPublishedModel: 'kein veröffentlichtes Schätzmodell',
    requirementNoItemGroup: 'das Modell hat keine Positionsgruppe',
    requirementNoPersonDaysUnit: 'das Modell bietet keine Personentage',
    requirementNoThreePointMethodology: 'das Modell verknüpft keine 3-Punkt-Methode',
    warningNoCurrency:
      'Für dieses Modell ist keine Währung konfiguriert, daher lassen sich die Kosten-Tabs in der neuen Schätzung nicht speichern.',
    projectTypeHint: 'Bestimmt, auf welchem Schätzmodell der Entwurf aufbaut.',
    noProjectTypeAvailable:
      'Kein Projekttyp in diesem Mandanten kann eine übernommene Schätzung aufnehmen. Das Schätzmodell benötigt Personentage als Einheit und eine 3-Punkt-Methode.',
    projectNameLabel: 'Projektname',
    projectDescriptionLabel: 'Projektbeschreibung',
    documentLinkLabel: 'Link zum KI-Beratungsdokument (optional)',
    documentLinkPlaceholder: 'https://…',
    submitButton: 'Schätzungsentwurf erstellen',
    cancelButton: 'Abbrechen',
    workstreamLabel: 'Workstream:',
    rangeLabel: '{optimistic}–{likely}–{pessimistic} PT',
    submitErrorTitle: 'Umwandlung fehlgeschlagen',
    noSelectionWarning:
      'Keine Arbeitspakete ausgewählt - der Entwurf wird nur aus den Projektstammdaten erstellt.',
    masterCheckboxLabel: 'Alle Arbeitspakete',
    workstreamCheckboxLabel: 'Alle Elemente in {name} umschalten',
    selectionCounter: '{wbs} PSP · {assumptions} Annahmen · {links} Phasenverknüpfungen ausgewählt',
    orphanedAssumptionsWarning: 'Verwaiste Annahmen: {count}',
    orphanedAssumptionsHint:
      'Diese Annahmen haben keine ausgewählte Zielphase und werden beim Import der ersten ausgewählten Phase zugeordnet.',
    assumptionImpactsLabel: 'Betrifft:',
    assumptionNoImpacts: 'Keine verknüpften Phasen',
    // EWM-986: conversion progress overlay.
    conversionTitle: 'AI Advisory wird in Schätzung umgewandelt',
    conversionSubtitle:
      'Wir erstellen den detaillierten Schätzungs-Tree - dies dauert üblicherweise 1–3 Minuten.',
    elapsedLabel: 'Vergangen',
    milestoneFetching: 'KI-Beratungsinhalte werden abgerufen',
    milestoneParsing: 'Strukturierte Abschnitte werden ausgewertet',
    milestoneBuilding: 'Schätzungsbaum wird erstellt',
    milestonePreparing: 'Auswahlvorschau wird vorbereitet',
    conversionTip:
      'Sie können anschließend auswählen, welche Bereiche in Ihre finale Schätzung übernommen werden sollen.',
    conversionOverrun: 'Dauert länger als üblich - bitte weiter warten.',
    cancelConversionButton: 'Umwandlung abbrechen',
    retryButton: 'Erneut versuchen',
    backToAdvisoryButton: 'Zurück zur AI Advisory',
  },
  aiAdvisory: {
    tenantInstructions: '',
    convertToEstimation: 'In Schätzung umwandeln',
    convertNoWorkBreakdown:
      'Diese Antwort enthält keine Arbeitsstruktur und kann daher nicht umgewandelt werden.',
    sharedBadge: 'Geteilt',
    sharedBadgeTitle: 'Von einem anderen Benutzer mit Ihnen geteilt',
    title: 'AI Advisory',
    subtitle: 'Erhalten Sie intelligente Beratung für Ihre Projektschätzungen',
    welcomeMessage:
      'Hallo! Ich bin Ihr AI Advisor. Ich kann Ihnen bei Projektschätzungen, Methodenauswahl, Ressourcenplanung und Kostenanalyse helfen. Wie kann ich Ihnen heute helfen?',
    placeholder: 'Fragen Sie mich alles über Projektschätzungen...',
    advisoryProvided: 'AI Advisory bereitgestellt',
    sendButton: 'Senden',
    helpText: 'Enter drücken zum Senden, Shift+Enter für neue Zeile',
    aiResponse:
      'Vielen Dank für Ihre Frage! Dies ist eine Platzhalter-Antwort. In der tatsächlichen Implementierung wäre dies mit einem LLM-Service verbunden, um intelligente Schätzungsberatung zu bieten.',
    loadingChatHistory: 'Lädt Chat-Verlauf...',
    failedToLoadChatHistory: 'Fehler beim Laden des Chat-Verlaufs',
    prefillQuestionUnavailable:
      'Die vorherige Frage konnte nicht geladen werden. Geben Sie Ihre Frage unten ein, um eine neue Beratung zu starten.',
    pdfExportFailed:
      'Das PDF konnte nicht erstellt werden. Bitte versuchen Sie es erneut oder exportieren Sie als Word.',
    generatingResponse: 'Antwort generieren...',
    activityThinking: 'Denkt nach...',
    activityWebSearch: 'Durchsucht das Web...',
    activityTool: 'Arbeitet mit {tool}...',
    answerIncomplete:
      'Die Generierung wurde unterbrochen - diese Antwort ist möglicherweise unvollständig.',
    deleteConversation: 'Unterhaltung löschen',
    deleteConversationTitle: 'Unterhaltung löschen',
    deleteConversationWarning:
      'Dies wird diese Unterhaltung und alle ihre Nachrichten dauerhaft löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteConversationConfirm: 'Unterhaltung löschen',
    shareConversation: 'Unterhaltung teilen',
    shareConversationTitle: 'AI Advisory teilen',
    shareConversationDescription:
      'Senden Sie einen Link zu dieser Unterhaltung an jemanden in Ihrem Mandanten.',
    shareConversationEmailLabel: 'Empfänger',
    shareConversationRecipientPlaceholder: 'Benutzer auswählen',
    shareConversationSend: 'Senden',
    shareConversationCopyLink: 'Link kopieren',
    shareConversationCancel: 'Abbrechen',
    shareConversationSuccess: 'Einladung gesendet',
    shareConversationError: 'Einladung konnte nicht gesendet werden',
    shareConversationNotAllowed: 'Empfänger muss im selben Mandanten sein',
    shareConversationNotFound: 'Unterhaltung nicht gefunden',
    shareConversationEmailRequired: 'Bitte wählen Sie einen Empfänger',
    linkCopied: 'Link in die Zwischenablage kopiert',
    newFolder: 'Neuer Ordner',
    newFolderDefaultName: 'Neuer Ordner',
    renameFolder: 'Ordner umbenennen',
    renameFolderConfirm: 'Speichern',
    renameFolderCancel: 'Abbrechen',
    renameFolderError: 'Ordner konnte nicht umbenannt werden',
    createFolderError: 'Ordner konnte nicht erstellt werden',
    deleteFolder: 'Ordner löschen',
    deleteFolderTitle: 'Ordner löschen',
    deleteFolderWarningWithContents:
      'Ordner „{name}" löschen? Die {count, plural, one {# Unterhaltung} other {# Unterhaltungen}} darin werden in die Liste ohne Ordner verschoben. Keine Unterhaltung wird gelöscht.',
    deleteFolderWarningEmpty: 'Ordner „{name}" löschen?',
    deleteFolderConfirm: 'Ordner löschen',
    moveToFolder: 'In Ordner verschieben',
    moveToFolderError: 'Unterhaltung konnte nicht verschoben werden',
    moveToFolderNoFolderOption: 'Kein Ordner',
    moveToFolderCreateNew: '+ Neuen Ordner erstellen',
    renameConversation: 'Unterhaltung umbenennen',
    renameConversationConfirm: 'Speichern',
    renameConversationCancel: 'Abbrechen',
    renameConversationError: 'Unterhaltung konnte nicht umbenannt werden',
  },
  estimates: {
    error: {
      loadingFailed: 'Schätzungen konnten nicht geladen werden.',
      retry: 'Erneut versuchen',
    },
    filters: {
      showOnlyMyLabel: 'Nur meine Schätzungen anzeigen',
      projectTypeLabel: 'Projekttyp',
      statusLabel: 'Status',
    },
    title: 'Schätzungen',
    table: {
      header: {
        projectName: 'Projektname',
        planningResponsible: 'Planungsverantwortlicher',
        method: 'Methode',
        projectType: 'Projekttyp',
        status: 'Status',
        estimate: 'Schätzung',
        createdAt: 'Erstellt am',
        updatedAt: 'Aktualisiert am',
        createdBy: 'Erstellt von',
        estimationUnit: 'Schätzeinheit',
      },
    },
    newEstimation: 'Neue Schätzung',
    myEstimations: 'Meine Schätzungen',
    allEstimations: 'Alle Schätzungen',
    continue: 'Fortsetzen',
  },
  newEstimation: {
    estimating: {
      assumptionQuestion: 'Möchten Sie Annahmen für die Phase {name} angeben?',
      noAssumptionsProvided: 'Keine Annahmen für die Phase {name} bereitgestellt.',
      selectMethodology: 'Wählen Sie die Methode für {name}.',
      title: 'Wollen Sie Ihre Projektphasen schätzen?',
      startEstimating: 'Schätzung starten',
      phaseTitle: 'Schätzmethode für diese Phase.',
      phaseWithInput: 'Bitte geben Sie Ihre Grobschätzung in {estimationUnit} an.',
      skipEstimating: 'Überspringen',
      phaseHeader: '{name} Schätzung',
      phaseHeaderSuffix: 'Schätzung',
      renamePhase: 'Phase umbenennen',
      savePhaseName: 'Phasenname speichern',
      cancelPhaseRename: 'Umbenennen abbrechen',
      renamePhaseError: 'Phase konnte nicht umbenannt werden',
      phaseName: 'Phasenname',
      methodology: 'Methode',
      notIncluded: 'Nicht berücksichtigt',
      phaseWithInputPlaceholder: 'Nr. der {estimationUnit}',
      estimatingSummary: 'Zusammenfassung der Schätzung',
      phaseValueCancel: 'Abbrechen',
      phaseValueSave: 'Speichern',
      total: 'Summe',
      estimate: 'Schätzung',
      phaseUnit: 'Schätzeinheit: {unit}',
      suggestedValueFormat: '{label} (Vorschlag: {value} {label})',
      suggestedValueFormatWithUserValue: '{userValue} {label} (Vorschlag: {value} {label})',
      fixedValueFormat: '{label} (Konstant: {value} {label})',
      calculatedValueFormat: 'Berechnet: {value} {unit}',
      summary: 'Zusammenfassung',
      assumptionsButton: 'Annahmen',
    },
    projectBasics: {
      projectInfo: {
        projectDescriptionLabel: 'Projektbeschreibung',
        projectDescriptionHelpText: 'Bitte beschreiben Sie Zweck, Umfang und Kontext des Projekts.',
        title: 'Starten Sie Ihr Estimator-Projekt',
        subtitle:
          'Bitte beantworten Sie einige Fragen und Estimator wird eine Übersicht ihrer Schätzung erstellen.',
        projectNameLabel: 'Projektname',
        planningResponsibleLabel: 'Planungsverantwortlicher',
        reviewerLabel: 'Reviewer',
        additionalContributorsLabel: 'Zusätzliche Planungsmitarbeiter',
        estimationLanguageLabel: 'Sprache',
        projectTypeLabel: 'Projekttyp',
        methodologyLabel: 'Schätzmethode',
        defaultEstimationUnitLabel: 'Standardschätzeinheit',
      },
      methodology: {
        title: 'Methode',
        subtitle: 'Wählen Sie Ihren Standardschätzansatz',
        defaultEstimationUnitLabel: 'Standardschätzeinheit',
      },
      projectType: {
        title: 'Projekttyp',
        subtitle: 'Wählen Sie den Projekttyp, um mit dem Schätzprozess zu beginnen.',
        estimationModelNotDefined:
          'Das Schätzmodell ist nicht definiert. Bitte kontaktieren Sie den Administrator.',
      },
    },
    metadata: {
      optional: {
        title: 'Optionale Stammdaten',
        subtitle: 'Möchten Sie weitere Details zu Ihrem Projekt angeben?',
      },
      mandatory: {
        title: 'Benötigte Stammdaten',
        subtitle: '{providedPercentage}% der benötigten Informationen wurden erfasst.',
      },
      emptyValueLabel: 'Nicht angegeben',
      noMandatoryMetadataDefinedSubtitle: 'Es sind keine verpflichtenden Stammdaten definiert.',
      noOptionalMetadataDefinedSubtitle: 'Es sind keine optionalen Stammdaten definiert.',
      invalidUrl: 'Bitte eine gültige URL eingeben',
    },
    title: 'Schätzschritte',
    buttons: {
      cancel: 'Schätzung abbrechen',
      nextStep: 'Nächster Schritt',
      previousStep: 'Vorheriger Schritt',
      createProject: 'Projekt erstellen',
      finishWizard: 'Assistent beenden',
    },
    projectPhases: {
      title: 'Projektphasen',
      loading: 'Lädt...',
      phaseName: 'Phasenname',
      included: 'Berücksichtigt',
      addPhase: 'Projektphase hinzufügen',
      creatingPhasesInProcess: 'Phasen erstellen, das kann einen Moment dauern...',
      editAssumptions: 'Annahmen ({count})',
      renamePhase: 'Phase umbenennen',
      savePhaseName: 'Phasenname speichern',
      cancelPhaseRename: 'Umbenennen abbrechen',
      renamePhaseError: 'Phase konnte nicht umbenannt werden',
    },
    phaseWithSelect: {
      placeholder: 'Auswählen',
      empty: 'Nicht angegeben',
    },
    review: {
      title: 'Überprüfen Sie Ihre Schätzung',
      subtitle: '{providedPercentage}% der vorgeschriebenen Informationen wurden bereitgestellt.',
      emptyValue: '[Nicht angegeben]',
      noMandatoryMetadataDefinedSubtitle: 'Es wurden keine verpflichtenden Stammdaten definiert.',
      aiReviewEnqueueLabel: 'AI-Bewertung initiieren',
      aiReviewSuccessfullyEnqueued:
        'Die AI-Bewertung wurde erfolgreich initiiert. Sie erhalten eine Benachrichtigung, sobald sie abgeschlossen ist.',
    },
    header: {
      salutation: 'Willkommen bei Estimator Schätzassistent, {username}!',
      unsaved: 'Nicht gespeicherte Version für das Projekt {projectName}',
      saved: '{versionName} für das Projekt {projectName}',
    },
    addAssumptionModal: {
      title: 'Annahme hinzufügen',
    },
    phaseAssumption: {
      decline: 'Abbrechen',
      save: 'Speichern',
      selectAssumptionType: 'Annahmetyp auswählen',
      provideYourAssumption: 'Ihre Annahme',
      assumptionType: 'Typ',
      assumptionDescription: 'Beschreibung',
    },
    continueEstimation: {
      loading: 'Bitte warten Sie, während wir die Daten Ihrer letzten Schätzung abrufen...',
    },
    setup: {
      title: 'Neue Schätzung erstellen',
      subtitle:
        'Richten Sie die grundlegenden Details für Ihr Schätzungsprojekt ein. Alle mit * markierten Felder sind erforderlich.',
      projectInfoSection: 'Projektinformationen',
      projectTypeSection: 'Projekttyp',
      methodologySection: 'Schätzmethodik',
      projectNameLabel: 'Projektname',
      planningResponsibleLabel: 'Planungsverantwortlicher',
      reviewerLabel: 'Prüfer',
      additionalContributorsLabel: 'Projektmitarbeiter',
      estimationLanguageLabel: 'Schätzungssprache',
      projectTypeSubtitle: 'Wählen Sie die Art des Projekts, an dem Sie arbeiten.',
      estimationModelNotDefined:
        'Für diesen Projekttyp ist kein Schätzungsmodell definiert. Bitte wenden Sie sich an den Administrator.',
      methodologySubtitle: 'Wählen Sie Ihren Standard-Schätzungsansatz.',
      defaultEstimationUnitLabel: 'Standard-Schätzungseinheit',
      continueButton: 'Erstellen & Fortfahren',
      cancelButton: 'Abbrechen',
      createError: 'Schätzung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    },
    chooseMode: {
      title: 'Wählen Sie Ihren Workflow',
      subtitle: 'Ihre Schätzung wurde erstellt. Wählen Sie, wie Sie fortfahren möchten.',
      wizard: {
        title: 'Schätzungsassistent-Modus',
        description:
          'Geführte, schrittweise Einrichtung, empfohlen für Standardabläufe oder weniger erfahrene Benutzer.',
        cta: 'Im Assistenten-Modus fortfahren',
      },
      detailed: {
        title: 'Detaillierter Schätzungsmodus',
        description:
          'Springen Sie direkt in die vollständige Detailansicht für fortgeschrittene Benutzer oder Feinabstimmungen.',
        cta: 'Im Detailmodus fortfahren',
      },
    },
    resource: {
      title: 'Ressourcen den Projektphasen zuweisen?',
      skip: 'Überspringen',
      startResourcing: 'Ressourcen hinzufügen starten',
      resourceHeader: 'Ressource {name}',
      phaseUnit: 'Schätzeinheit: {unit}',
      methodology: 'Methode',
      estimate: 'Schätzung',
      delta: 'Delta',
      assignResourcesForPhase: 'Ressourcen für die Phase in {unit} zuweisen',
      valueSave: 'Speichern',
      valueNotNow: 'Abbrechen',
      summary: 'Zusammenfassung',
      resourceSummary: 'Ressourcenzusammenfassung',
      subTotal: 'Zwischensumme',
      total: 'Summe',
      notIncluded: 'Nicht berücksichtigt',
    },
    costs: {
      title: 'Kosten den Projektphasen zuweisen?',
      skip: 'Überspringen',
      startAddingCosts: 'Kosten hinzufügen',
      costHeader: 'Kosten',
      selectCurrency: 'Kostenwährung auswählen',
      costCurrency: 'Kostenwährung',
      selectCurrencyPlaceholder: 'Auswählen',
      empty: '![Leer]',
      notNow: 'Abbrechen',
      save: 'Speichern',
      assignCostsForResourceType: 'Kosten für jede Ressourcenkategorie festlegen',
      total: 'Gesamtsumme',
      subTotal: 'Zwischensumme',
      notIncluded: 'Nicht enthalten',
      costSummary: 'Kostenübersicht',
      phaseUnit: 'Schätzeinheit: {unit}',
      costUnit: 'Kosteneinheit: {currencyCode}',
      highLevelDirectCostEstimation:
        'Geben Sie eine grobe Schätzung der nicht-personenbezogenen Kosten an',
      resourceCostsTableTitle: 'Ressourcenkosten',
      directCostsTableTitle: 'Nicht-Personenbezogene Kosten',
      directCosts: 'Direkte Kosten',
      grandTotal: 'Gesamtsumme',
      totalProjectCost: 'Projektgesamtkosten',
    },
  },
  dashboard: {
    estimationButtons: {
      continue: 'Fortsetzen der Schätzung von',
      noEstimationsYet: 'Sie haben noch keine Schätzungen',
      createNew: 'Eine neue Schätzung erstellen',
      newEstimation: 'Neues Schätzprojekt',
      strategy: 'Strategie',
    },
    steps: {
      title: 'Wie benutzt man den Estimator?',
      buttons: {
        back: 'Zurück zu {previousStep}',
        continue: 'Weiter zu {nextStep}',
        expand: 'Ausklappen',
        collapse: 'Einklappen',
        learnAbout: 'Erfahren Sie mehr über {currentStep}',
        showLess: 'Weniger anzeigen',
      },
      guide: {
        aiAdvisory: {
          url: '',
          title: 'KI-Beratung',
          description: {
            short:
              'Optionaler Vorab-Schritt: Starten Sie ein Gespräch mit dem KI-Berater, um aus einer kurzen Projektbeschreibung eine erste Schätzung zu erzeugen.',
            long: 'Bevor Sie eine neue Schätzung manuell erstellen, können Sie die KI-Beratung als optionalen Vorab-Schritt nutzen. Der KI-Berater hilft Ihnen, aus einer kurzen Projektbeschreibung eine erste Schätzung zu generieren, die Sie in den folgenden Schritten weiter verfeinern können. Dieser Schritt ist vollständig optional — Sie können auch direkt mit dem Setup beginnen.',
          },
        },
        basics: {
          url: '',
          title: 'Setup',
          description: {
            short:
              'Bitte hinterlegen Sie hier die Grunddaten des Projektes wie Name, Art des Projekts, beteiligte Personen und der Schätzmethode.',
            long: 'Im ersten Schritt sind hier die grundlegenden Daten des Projektes zu hinterlegen. Dazu gehören der Projektname, die Projektart, die beteiligten Personen und die gewählte Schätzmethode. Diese Informationen bilden die Grundlage für den weiteren Verlauf. Stellen Sie sicher, dass diese Angaben präzise und vollständig sind, um eine fundierte Schätzung zu ermöglichen.',
          },
        },
        chooseMode: {
          url: '',
          title: 'Modus wählen',
          description: {
            short:
              'Nach dem Setup wählen Sie, wie es weitergeht: Estimation Wizard Mode (geführt, Schritt für Schritt) oder Estimation Detailed Mode (direkte volle Kontrolle).',
            long: 'Nachdem Sie das Setup abgeschlossen haben, entscheiden Sie, wie Sie Ihre Schätzung fortsetzen möchten. Wählen Sie den Estimation Wizard Mode für ein geführtes, schrittweises Erlebnis, das Sie durch jede Phase führt — empfohlen für Standardabläufe oder weniger erfahrene Nutzer. Wählen Sie den Estimation Detailed Mode, um direkt in die vollständige Detailansicht zu springen, geeignet für erfahrene Nutzer oder Feinabstimmungen. Die darauf folgenden Prozessschritte (Stammdaten, Phasen, Schätzung, Ressourcen, Kosten, Überprüfung) sind identisch und über beide Modi zugänglich.',
          },
        },
        metadata: {
          url: '',
          title: 'Stammdaten',
          description: {
            short:
              'Bitte erfassen Sie die zentralen Rahmenbedingungen Ihres Projekts, einschließlich Zielsetzung, Umfang und grobem Zeitrahmen.',
            long: 'Im nächsten Schritt erfassen Sie die zentralen Rahmenbedingungen Ihres Projekts. Dazu gehören die Zielsetzung, der Umfang des Projekts und der grobe Zeitrahmen. Diese Stammdaten dienen als Basis für alle weiteren Planungsschritte und ermöglichen es, den Projekterfolg effektiv zu steuern. Es ist wichtig, diese Daten klar zu definieren, um den weiteren Prozess zu unterstützen.',
          },
        },
        projectPhases: {
          url: '',
          title: 'Phasen',
          description: {
            short:
              'Bitte teilen Sie das Projekt in verschiedene Phasen auf und dokumentieren Sie für jede Phase spezifische Planungsannahmen.',
            long: 'Hier teilen Sie das Projekt in verschiedene Phasen auf. Diese Phasen helfen Ihnen, den Projektverlauf besser zu strukturieren und zu kontrollieren. Sie können für jede Phase spezifische Schätzannahmen in unterschiedlichen Kategorien (zB Scope, Ressourcen, Timeline, etc.) dokumentieren. So ermöglicht es Ihnen, diese Annahmen jederzeit im Blick zu behalten und gegebenenfalls Anpassungen vorzunehmen.',
          },
        },
        estimating: {
          url: '',
          title: 'Schätzung',
          description: {
            short:
              'Bitte schätzen Sie den Aufwand für jede Projektphase/-subphase (Arbeitspaket) und berechnen Sie den notwendigen Ressourceneinsatz.',
            long: 'In diesem Schritt schätzen Sie den Aufwand für jede Phase/Subphase (Arbeitspaket) Ihres Projekts. Es unterstützt Sie dabei, indem es verschiedene Methoden zur Aufwandsschätzung anbietet. Sie können hier den erforderlichen Ressourceneinsatz präzise kalkulieren. Diese Schätzungen sind entscheidend für die spätere Kostenplanung Ihres Projekts.',
          },
        },
        resourcing: {
          url: '',
          title: 'Ressourcen',
          description: {
            short:
              'Bitte weisen Sie die personellen Ressourcen, unterschieden in interne/externe und fachliche/IT-Ressourcen, den Aufgaben zu.',
            long: 'Anschließend weisen Sie die personellen Ressourcen den einzelnen Phasen und Aufgaben zu. Sie können zwischen internen und externen sowie fachlichen und IT-Ressourcen unterscheiden und diese entsprechend zuordnen. Ziel ist es, die verfügbaren personellen Ressourcen effizient zu nutzen und Engpässe zu vermeiden. Es hilft Ihnen dabei, die Ressourcen auf die Projektanforderungen zu verteilen.',
          },
        },
        costing: {
          url: '',
          title: 'Kosten',
          description: {
            short:
              'Bitte lassen Sie sich - unter Verwendung der Tagessätze der Ressourcengruppen - die Projektkosten berechnen und ergänzen Sie diese ggf. um anfallende Sachkosten.',
            long: 'Basierend auf den vorherigen Schätzungen lassen Sie nun die voraussichtlichen Kosten für Ihr Projekt berechnen. Es verwendet die unterschiedlichen Tagessätze für die in Schritt 5 definierten Ressourcengruppen, um eine präzise Kostenschätzung zu erstellen. Zusätzlich können Sie die berechneten Projektkosten ggf. um anfallende Sachkosten ergänzen, um ein vollständiges Kostenbild zu erhalten. Diese Berechnung dient als Grundlage für das Budget Ihres Projekts. Überprüfen Sie die Berechnungen, um sicherzustellen, dass das Budget eingehalten wird.',
          },
        },
        review: {
          url: '',
          title: 'Überprüfung',
          description: {
            short:
              'Hier haben Sie die Möglichkeit, Ihre Schätzung durch  eine KI validieren zu lassen und/oder von einem anderen Projektmanager Feedback in einer Peer-Review einzuholen.',
            long: 'Schließlich haben Sie die Möglichkeit, Ihre Schätzung durch zwei externe Überprüfungen zu validieren. Im ersten Schritt können Sie Ihre Schätzungen von einem KI-Bot überprüfen lassen, der Ihnen sofortiges Feedback zur Genauigkeit und Plausibilität gibt. Im zweiten Schritt können Sie Ihre Schätzung zur Peer-Review an einen anderen Projektmanager weiterleiten.',
          },
        },
      },
    },
  },
  header: {
    notifications: {
      title: 'Benachrichtigungen',
      readAll: 'Alle als gelesen markieren',
      noNew: 'Keine neuen Benachrichtigungen.',
      all: 'Alle',
      unread: 'Ungelesen',
      user: {
        assignedAsContributorToEstimation:
          'Sie wurden als Planungsmitarbeiter einer Schätzung zugewiesen ({projectName}).',
        assignedAsPhaseLead:
          'Sie wurden als Phasenleiter einem Schätzobjekt zugewiesen ({projectName}).',
        assignedAsPlanningResponsibleToEstimation:
          'Sie wurden als Planungsverantwortlicher der Schätzung zugewiesen ({projectName}).',
        assignedAsReviewerToEstimation:
          'Sie wurden als Reviewer der Schätzung zugewiesen ({projectName}).',
      },
      review: {
        requested: 'Überprüfung eines Schätzobjekts angefordert ({projectName}).',
        approved: 'Schätzobjekt genehmigt ({projectName})',
        cancelled: 'Schätzobjekt abgelehnt ({projectName})',
        outcomeCompleted:
          'Die von Ihnen betreute Schätzungsüberprüfung wurde abgeschlossen ({projectName}).',
        outcomeCanceled:
          'Die von Ihnen betreute Schätzungsüberprüfung wurde abgebrochen ({projectName}).',
      },
      comment: {
        addedToEstimationItem: 'Ein Kommentar wurde hinzugefügt ({projectName}).',
      },
      estimation: {
        newVersion: 'Eine neue Version der Schätzung wurde erstellt ({projectName}).',
        aiReview: 'Die AI-Bewertung wurde für die Schätzung erstellt ({projectName}).',
      },
      reviewCommentsSummary: {
        available:
          'Zusammenfassung der Review-Kommentare ist für die Schätzung verfügbar ({projectName}).',
      },
      phase: {
        statusChanged: 'Der Status einer Phase hat sich geändert ({projectName}).',
        blocked: 'Eine Phase wurde blockiert ({projectName}).',
        unblocked: 'Die Blockierung einer Phase wurde aufgehoben ({projectName}).',
        itemAssigned: 'Ein Objekt wurde einer Phase zugewiesen ({projectName}).',
        deadlineApproaching: 'Eine Phasenfrist rückt näher ({projectName}).',
      },
      conversation: {
        shared: 'Eine AI Advisory Unterhaltung wurde mit Ihnen geteilt.',
      },
      deletedProject: 'Gelöscht',
      showAll: 'Alle Benachrichtigungen anzeigen',
      newCount: '{count} Neu',
      markAsRead: 'Als gelesen markieren',
    },
  },
  estimationNavigation: {
    wizardMode: 'Assistenten-Modus',
    cancelEstimation: 'Schätzung abbrechen',
    version: 'Version',
    basics: {
      mainTitle: 'Setup',
      project: 'Projekt',
      projectType: 'Projektyp',
      methodology: 'Methode',
    },
    metadata: {
      mainTitle: 'Stammdaten',
      mandatory: 'Benötigt',
      optional: 'Optional',
    },
    phases: 'Phasen',
    estimating: 'Schätzung',
    resourcing: 'Ressourcen',
    costing: 'Kosten',
    review: 'Überprüfung',
    currentVersion: 'Version {versionName}',
  },
  estimationDetail: {
    tab: {
      project: {
        label: 'Projekt',
      },
      metadata: {
        label: 'Stammdaten',
        mandatoryTitle: 'Verpflichtende Stammdaten',
        optionalTitle: 'Optionale Stammdaten',
        progressSentenceFormattedWithAmountPercentage:
          '{amountPercentage}% der verpflichtenden Informationen wurden bereitgestellt.',
        aiAdvisoryDocumentLinkLabel: 'KI-Beratungs-Link',
        unsavedChangesTitle: 'Nicht gespeicherte Änderungen',
        unsavedChangesWarning:
          'Sie haben nicht gespeicherte Änderungen im Stammdatenformular. Möchten Sie diese vor dem Verlassen speichern?',
        unsavedChangesSave: 'Speichern und verlassen',
        unsavedChangesDiscard: 'Verwerfen und verlassen',
        unsavedChangesCancel: 'Abbrechen',
        unsavedChangesValidationError:
          'Einige Pflichtfelder fehlen oder sind ungültig. Bitte füllen Sie diese aus, bevor Sie speichern.',
      },
      estimation: {
        label: 'Schätzung',
      },
      estimationAssumptions: {
        label: 'Annahmen',
      },
      resource: {
        label: 'Ressourcen',
        resetNamesToDefaults: 'Alle auf Standard zurücksetzen',
      },
      resourceCost: {
        label: 'Ressourcenkosten',
      },
      directCost: {
        label: 'Direkte Kosten',
      },
      costSummary: {
        label: 'Kostenzusammenfassung',
      },
      review: {
        label: 'Überprüfung',
      },
      managementReport: {
        label: 'Managementbericht',
      },
    },
    estimationItemDetailModal: {
      title: 'Schätzphase bearbeiten',
      assumptionsButton: 'Annahmen',
      commentsButton: 'Kommentare',
      removePhaseButton: 'Phase entfernen',
      overrideOriginalEstimateButton: 'Schätzung aktualisieren',
      subItemsTitle: 'Unterelemente in der Phase',
      unsavedChangesTitle: 'Ungespeicherte Änderungen',
      unsavedChangesWarning:
        'Sie haben Änderungen an dieser Schätzphase vorgenommen, die noch nicht gespeichert wurden. Wie möchten Sie fortfahren?',
      discardAndCloseButton: 'Verwerfen und schließen',
    },
    estimationItemEditation: {
      descriptionPlaceholder:
        'Aussagekräftige Kurzbeschreibung für das Management (max. 210 Zeichen)',
      phaseName: 'Phasenname',
      phaseLead: 'Phasenverantwortlicher',
      description: 'Beschreibung',
      methodology: 'Methode',
      estimate: 'Schätzung',
    },
    estimationItemsGrouped: {
      estimationUnit: 'Schätzeinheit',
    },
    estimationItemsTable: {
      renameItem: 'Umbenennen',
      saveItemName: 'Namen speichern',
      cancelItemRename: 'Umbenennen abbrechen',
      estimationUnit: 'Schätzeinheit',
      referenceNumber: '#',
      phaseLead: 'Phasenverantwortlicher',
      methodology: 'Methode',
      estimate: 'Schätzung',
      estimateCheck: 'Schätzprüfung',
      included: 'Berücksichtigt',
      detailsButton: 'Details',
      assumptionsButton: 'Annahmen',
      addPhaseButton: 'Phase hinzufügen',
      suggestion: 'Vorschlag',
      emptyTableGroupName: 'Phase Name',
      emptyTableText: 'Derzeit gibt es keine Unterelemente für diese Phase.',
      subtotal: 'Zwischensumme',
      commentsButton: 'Kommentare',
    },
    estimationItemOmitModal: {
      title: 'Grund angeben',
      reason: {
        placeholder: 'Sinnvolle kurze Beschreibung für das Management (max. 210 Zeichen).',
      },
      confirmButton: 'Entfernung bestätigen',
    },
    estimationItemDeleteModal: {
      title: 'Phase löschen',
      warningMessage:
        'Dies wird die Phase und alle ihre Unterphasen löschen. Der Vorgang kann nicht rückgängig gemacht werden.',
      confirmButton: 'Löschen bestätigen',
    },
    deleteGroupModal: {
      title: 'Gruppe löschen',
      warningMessage:
        'Dies wird die Gruppe und alle ihre Typen löschen. Die Typen werden in die ungruppierte Sektion verschoben.',
      confirmButton: 'Löschen bestätigen',
    },
    reviewCommentsSummary: {
      title: 'Zusammenfassung der Review-Kommentare',
      notAvailable:
        'Noch keine Zusammenfassung verfügbar. Schließen Sie einen Review-Zyklus ab (Zurückschicken oder Genehmigen), um die Zusammenfassung hier zu sehen.',
    },
    sendBackButton: 'Zurückschicken',
    approveButton: 'Genehmigen',
    cancelReviewButton: 'Überprüfung abbrechen',
    startReviewButton: 'Überprüfung starten',
    estimationItemsResourceCostSummaryTable: {
      estimate: 'Schätzung',
      subtotal: 'Zwischensumme',
      totalEfforts: 'Gesamtaufwand',
    },
    costEstimationItemsGrouped: {
      costUnit: 'Kosteneinheit',
    },
    costEstimationItemsTable: {
      referenceNumber: '#',
      subtotal: 'Zwischensumme',
      detailsButton: 'Details',
      assumptionsButton: 'Annahmen',
      addEstimationItemButton: 'Kosten hinzufügen',
      emptyTableGroupName: 'Kostenname',
      emptyTableText: 'Derzeit gibt es keine Unterelemente für diese Kosten.',
      included: 'Berücksichtigt',
      commentsButton: 'Kommentare',
    },
    directCosts: {
      detail: {
        sum: 'Summe',
        estimationItemName: 'Kostenname',
        description: 'Beschreibung',
        title: 'Kosten bearbeiten',
        assumptionsButton: 'Annahmen',
        commentsButton: 'Kommentare',
        overrideOriginalEstimateButton: 'Ursprüngliche Schätzung aktualisieren',
        subItemsTitle: 'Unterkosten',
        saved: 'Costs of sub-estimation items of "{mainEstimationItemName}" have been saved.',
      },
      costBreakDownTitle: 'Aufschlüsselung der direkten Kosten',
    },
    estimationItemsCostSummarySummaryTable: {
      estimate: 'Schätzung',
      subtotal: 'Zwischensumme',
    },
    estimationItemsDirectCostSummaryTable: {
      estimate: 'Schätzung',
      subtotal: 'Zwischensumme',
    },
    resourceCosts: {
      costPerUnitTitle: 'Kosten pro Ressourceneinheit',
      currency: 'Währung',
      costBreakDownTitle: 'Aufschlüsselung der Ressourcenkosten',
      estimationUnit: 'Schätzeinheit',
      costUnit: 'Kosteneinheit',
      subTotal: 'Zwischensumme',
      costsRecalculating: 'Berechnen',
    },
    currentVersion: 'Version: {versionNumber}',
    activeVersion: 'Aktive Version: {versionNumber}',
    workingVersion: 'Arbeitsversion: {versionNumber}',
    createNewVersion: 'Neue Version erstellen',
    viewAllVersions: 'Alle Versionen anzeigen',
    versionName: 'Versionsname',
    versionCreated: 'Version {versionName} wurde erfolgreich erstellt.',
    renameVersion: 'Version umbenennen',
    versionRenamed: 'Die Version wurde erfolgreich umbenannt',
    methodologyChangeConfirmationModal: {
      title: 'Änderung der Methodologie',
      warningMessage:
        'Diese Aktion wird die Methodologie in allen Unterphasen ändern. Infolgedessen werden die Parameter neu generiert und die eingegebenen Schätzungen gehen verloren. Der Vorgang kann nicht rückgängig gemacht werden.',
    },
    detail: {
      saved: 'Schätzposten "{mainEstimationItemName}" wurde gespeichert.',
    },
    archivedModelBanner: {
      text: 'Dieses Schätzmodell wurde archiviert. Bestehende Werte bleiben nutzbar.',
      dismiss: 'Ausblenden',
    },
  },
  assumptions: {
    listModal: {
      titleWithPhaseNameFormatted: 'Annahmen für {phaseName}',
    },
    table: {
      header: {
        order: '#',
        assumptionId: 'Annahmen-ID',
        estimationItem: 'Schätzobjekt',
        assumptionType: 'Annahmetyp',
        assumption: 'Annahme',
        isValid: 'Aktiv',
      },
      export: {
        title: 'Annahmen',
      },
    },
    addButton: 'Neue Annahme hinzufügen',
  },
  api: {
    enum: {
      ApiEstimationStage: {
        IN_CREATION: 'In Erstellung',
        IN_PROCESS: 'In Bearbeitung',
        IN_REVIEW: 'In Überprüfung',
        APPROVED: 'Genehmigt',
      },
      EstimationUnit: {
        PD: 'Personentage',
        HOURS: 'Stunden',
        STORY_POINTS: 'Story Points',
        CURRENCY: 'Währung',
      },
      ApiEstimationAdditionalFieldType: {
        TEXT: 'Text',
        FORMATTED_TEXT: 'Langtext',
        DURATION_TIME_SPAN: 'Dauer',
        SELECTABLE: 'Auswählbar',
        DATE: 'Datum',
        DOCUMENT_LINK: 'Dokumentenlink / URL',
      },
    },
  },
  customEstimationItemCreationModal: {
    title: 'Benutzerdefinierte Phase erstellen',
    phaseName: 'Phasenname',
    estimationGroup: 'Schätzgruppe',
    noEstimationGroupsAvailable: 'Für diese Auswahl ist keine Schätzgruppe verfügbar.',
    parent: 'Übergeordnete Phase',
    parentNone: '(keine — als oberste Ebene erstellen)',
    phaseLead: 'Phasenverantwortlicher',
    methodology: 'Methode',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Sinnvolle kurze Beschreibung für das Management (max. 210 Zeichen).',
  },
  fieldError: {
    required: 'Erforderlich',
    wrongValue: 'Falscher Wert',
    maxLength: 'Der Text hat die maximale Grenze der Zeichen überschritten',
  },
  assumptionEditationModal: {
    title: 'Bearbeitung der Annahme',
    assumptionType: 'Annahmetyp',
    assumptionCategoryDropdownPlaceholder: 'Typ auswählen',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Sinnvolle kurze Beschreibung für das Management (max. 210 Zeichen).',
  },
  assumptionCreationModal: {
    title: 'Erstellung der Annahme',
    assumptionType: 'Annahmetyp',
    assumptionCategoryDropdownPlaceholder: 'Typ auswählen',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Sinnvolle kurze Beschreibung für das Management (max. 210 Zeichen).',
  },
  assumptionDeletionConfirmationModal: {
    title: 'Annahme löschen',
    warningMessage:
      'Dies wird die Annahme löschen. Der Vorgang kann nicht rückgängig gemacht werden.',
    confirmButton: 'Löschen bestätigen',
  },
  dropdown: {
    emptyPlaceholder: 'Auswählen',
  },
  durationFormField: {
    wrongFormat: 'Falsches Format (DDD.HH:MM).',
  },
  estimationVersions: {
    versionName: 'Versionsname',
    status: 'Status',
    lastUpdated: 'Zuletzt aktualisiert am',
    lastUpdatedBy: 'Zuletzt aktualisiert von',
    createdAt: 'Erstellt am',
    createdBy: 'Erstellt von',
    estimate: 'Schätzung',
  },
  comments: {
    modalTitleWithPhaseNameFormatted: 'Kommentare zu {phaseName}',
    contextTypeEstimationLabel: 'Schätzung',
    contextTypeResourcingLabel: 'Ressource',
    contextTypeCostingLabel: 'Kosten',
    typeMessagePlaceholder: 'Geben Sie Ihre Nachricht ein',
    messageLabel: 'Nachricht:',
    hintTitle:
      'Drücken Sie Strg (Cmd auf Mac) + Enter zum Senden und Esc zum Schließen des Fensters',
    postingComment: 'Kommentar senden',
    emptyState: 'Noch keine Kommentare — starten Sie die Unterhaltung.',
  },
  genericError: {
    errorOccured: 'Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Support.',
  },
  notFound: {
    homePageButton: 'Startseite',
    resourceDoesNotExist:
      'Die angeforderte Ressource existiert nicht, wurde verschoben oder konnte nicht gefunden werden.',
  },
  customDirectCostCreationModal: {
    title: 'Benutzerdefinierte Kosten erstellen',
    costName: 'Kostenname',
    estimationGroup: 'Schätzgruppe',
    description: 'Beschreibung',
    descriptionPlaceholder:
      'Aussagekräftige kurze Beschreibung für das Management (max. 210 Zeichen)',
  },
  export: {
    estimation: {
      masterdata: 'Stammdaten',
      reference: '#',
      group: 'Gruppe',
      phase: 'Phase',
      phaseLead: 'Phasenleiter',
      methodology: 'Methodologie',
      estimate: 'Schätzung',
      estimateCheck: 'Schätzprüfung',
      costsSum: 'Kostenaufstellung',
      total: 'Summe',
      assumptions: 'Annahmen',
    },
    pdf: {
      pageNOfM: 'Seite {currentPageNumber} von {totalPagesCount}',
      poweredBy: 'Betrieben von Estimation.World',
    },
  },
  aiReviewParamsModal: {
    title: 'AI-Bewertungsparameter',
    helpTitle: 'Bitte geben Sie die erforderlichen AI-Bewertungsparameter an.',
    helpText:
      'Die erstellte Anfrage wird so schnell wie möglich bearbeitet, abhängig von der aktuellen Auslastung (normalerweise innerhalb weniger Minuten). Die Antwort wird an die mit Ihrem Konto verknüpfte E-Mail-Adresse gesendet, und Sie werden auch in der Anwendung benachrichtigt.',
    maxWordsCount: 'Maximale gewünschte Wortanzahl',
    language: 'Sprache',
    createRequest: 'Anfrage erstellen',
  },
  aiReviewViewModal: {
    title: 'Projekt AI-Bewertung',
    copy: 'Kopieren',
    forward: 'Per E-Mail weiterleiten',
    export: 'Als PDF exportieren',
    language: 'Sprache',
    noReview: 'Die Schätzung enthält keine AI-Bewertung für die ausgewählte Sprache.',
    reviewCreationDate: 'Sie sehen die AI-Bewertung, die erstellt wurde am {date}',
  },
  newAppVersionToast: {
    newVersionDeployed:
      'Eine neue Version der Anwendung wurde bereitgestellt. Es wird empfohlen, die Seite neu zu laden.',
    reloadButton: 'Klicken Sie hier, um die Seite neu zu laden.',
  },
  unauthorized: {
    title: '403 - Nicht autorisiert',
    youDoNotHaveAccess: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
    homePageButton: 'Startseite',
  },
  localizableFormField: {
    provideTranslation: '[Übersetzung bereitstellen]',
    translationFieldPlaceholder: 'Übersetzung für {language}',
  },
  deleteProjectButton: {
    deleteEstimationConfirmationText:
      'Sind Sie sicher, dass Sie die Schätzung "{projectName}" löschen möchten?',
    estimationDeletedConfirmationTitle: 'Bestätigung',
    estimationSuccessfullyDeleted: 'Die Schätzung wurde erfolgreich gelöscht.',
  },
  error: {
    code: {
      GENERAL: 'Ein Fehler ist aufgetreten.',
      VALIDATION: 'Validierungsfehler',
      DOMAIN_ERROR: 'Ein Fehler ist aufgetreten.',
      ENTITY_NOT_FOUND: 'Entität nicht gefunden.',
      ESTIMATION_ITEM_ASSUMPTION_NOT_FOUND: 'Annahme nicht gefunden.',
      ESTIMATION_ITEM_NOT_FOUND: 'Phase nicht gefunden.',
      ESTIMATION_NOT_FOUND: 'Schätzung nicht gefunden.',
      PROJECT_TYPE_CURRENCY_NOT_FOUND: 'Nicht unterstützte Währung.',
      PROJECT_TYPE_NOT_FOUND: 'Projekttyp nicht gefunden.',
      PROJECT_NOT_FOUND: 'Projekt nicht gefunden.',
      ESTIMATION_COST_NOT_FOUND: 'Schätzkosten nicht gefunden.',
      RESOURCE_TYPE_COST_NOT_FOUND: 'Ressourcentyp nicht gefunden.',
      USER_NOT_FOUND: 'Benutzer nicht gefunden.',
      LOCALIZATION_NOT_FOUND: 'Lokalisierung nicht gefunden.',
      ESTIMATION_USER_ASSIGNMENT_NOT_FOUND: 'Schätzung - Benutzerzuweisung nicht gefunden.',
      ESTIMATION_MODEL_ITEM_NOT_FOUND: 'Schätzmodellelement nicht gefunden.',
      ESTIMATION_ITEM_COMMENT_NOT_FOUND: 'Phasenkommentar nicht gefunden.',
      ESTIMATION_COMMENT_NOT_FOUND: 'Schätzkommentar nicht gefunden.',
      COMMENT_BASE_NOT_FOUND: 'Kommentar nicht gefunden.',
      TENANT_NOT_FOUND: 'Mandant nicht gefunden.',
      ROLE_NOT_FOUND: 'Rolle nicht gefunden.',
      PROJECT_NOTIFICATION_NOT_FOUND: 'Projektnachricht nicht gefunden.',
      NOTIFICATION_BASE_NOT_FOUND: 'Nachricht nicht gefunden.',
      ESTIMATION_NOTIFICATION_NOT_FOUND: 'Schätzbenachrichtigung nicht gefunden.',
      ESTIMATION_ITEM_NOTIFICATION_NOT_FOUND: 'Phasenbenachrichtigung nicht gefunden.',
      COMMENT_NOTIFICATION_NOT_FOUND: 'Kommentarsbenachrichtigung nicht gefunden.',
      ESTIMATION_MODEL_UNIT_NOT_FOUND: 'Schätzmodelleinheit nicht gefunden.',
      ESTIMATION_MODEL_ITEM_PARAMETER_NOT_FOUND: 'Schätzmodellelement-Parameter nicht gefunden.',
      ESTIMATION_MODEL_ASSUMPTION_CATEGORY_NOT_FOUND: 'Annahmetyp nicht gefunden.',
      ESTIMATION_MODEL_ADDITIONAL_FIELD_DEFINITION_NOT_FOUND: 'Stammdatenfeld nicht gefunden.',
      ESTIMATION_MODEL_NOT_FOUND: 'Schätzmodell nicht gefunden.',
      METHODOLOGY_PARAMETER_NOT_FOUND: 'Methodeparameter nicht gefunden.',
      METHODOLOGY_NOT_FOUND: 'Methode nicht gefunden.',
      ESTIMATION_ITEM_RESOURCE_NOT_FOUND: 'Phasenressource nicht gefunden.',
      ESTIMATION_ITEM_PARAMETER_NOT_FOUND: 'Phasenparameter nicht gefunden.',
      ESTIMATION_ASSUMPTION_NOT_FOUND: 'Schätzannahme nicht gefunden.',
      ESTIMATION_ADDITIONAL_FIELD_NOT_FOUND: 'Schätzstammdatenfeld nicht gefunden.',
      CURRENCY_CONVERSION_RATE_NOT_FOUND: 'Währungsumrechnungskurs nicht gefunden.',
      ESTIMATION_MODEL_METHODOLOGY_NOT_FOUND: 'Schätzmethode nicht gefunden.',
      RESOURCE_TYPE_NOT_FOUND: 'Ressourcentyp nicht gefunden.',
      COST_TYPE_NOT_FOUND: 'Kostentyp nicht gefunden.',
      CURRENCY_NOT_FOUND: 'Währung nicht gefunden.',
      CALCULATION_FORMULA_EVALUATION_ERROR: 'Fehler bei der Berechnung der Formel.',
      SUM_ITEMS_EXCEPT_ARGUMENTS_MUST_BE_QUOTED:
        "sumItemsExcept-Funktionsargumente müssen in Anführungszeichen stehen. Verwenden Sie sumItemsExcept('item1', 'item2') anstelle von sumItemsExcept(item1, item2).",
      CALCULATION_MISSING_INPUT_DATA: 'Fehlende Eingabedaten bei der Berechnung.',
      CALCULATION_MISSING_PARAMETER_VALUE: 'Fehlender Parameterwert bei der Berechnung.',
      WRONG_ASSUMPTION_CATEGORY: 'Falscher Annahmetyp.',
      WRONG_UNIT: 'Falsche Schätzeinheit.',
      WRONG_ESTIMATION_UNIT_PARENT: 'Falsche Schätzeinheit.',
      CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_PARAMS: 'Berechnete Phase kann keine Parameter haben.',
      CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_METHODOLOGY:
        'Berechnete Phase kann keine Methode haben.',
      UNCALCULATED_ESTIMATION_ITEM_MUST_HAVE_PARAMS: 'Modifizierbare Phase muss Parameter haben.',
      METHODOLOGY_CANNOT_BE_SET_WHEN_MODEL_ITEM_HAS_PARAMS:
        'Methode kann nicht festgelegt werden, wenn das zugrunde liegende Modellphase Parameter hat.',
      METHODOLOGY_UNSUPPORTED_BY_MODEL: 'Die Methode wird vom Modell nicht unterstützt.',
      OMIT_REASON_CAN_ONLY_BE_SET_FOR_OMITTED_ESTIMATION_ITEM:
        'Ein Grund für das Auslassen kann nur für eine ausgelassene Phase festgelegt werden.',
      OMIT_REASON_MUST_BE_SET_FOR_OMITTED_ESTIMATION_ITEM:
        'Ein Grund für das Auslassen muss für eine erforderliche ausgelassene Phase festgelegt werden.',
      ESTIMATION_ADDITIONAL_FIELD_WRONG_DEFINITION: 'Falsche Definition des Schätzstammdatenfeld.',
      CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DURATION:
        'Dauer-Stammdatenfeld kann nicht analysiert werden.',
      ESTIMATION_ADDITIONAL_FIELD_OF_TYPE_SELECTABLE_CONTAINS_WRONG_VALUE:
        'Auswählbares Schätzstammdatenfeld enthält falschen Wert.',
      USER_NOT_REVIEWER: 'Der Benutzer ist kein Reviewer.',
      CALCULATION_FORMULA_MUST_BE_SET_FOR_METHODOLOGY:
        'Eine Berechnungsformel muss für die Methode festgelegt werden.',
      METHODOLOGY_MUST_HAVE_AT_LEAST_ONE_PARAMETER:
        'Die Methode muss mindestens einen Parameter haben.',
      CANNOT_DELETE_METHODOLOGY_IN_USE:
        'Die Methode kann nicht gelöscht werden, da sie in Modell(en) verwendet wird.',
      ESTIMATION_ITEM_BASED_ON_MODEL_CANNOT_HAVE_THIS_PARENT:
        'Die auf einem Modell basierende Phase kann diese übergeordnete Phase nicht haben.',
      WRONG_ESTIMATION_ITEMS_PARAMETERS_COUNT: 'Falsche Anzahl von Parametern für die Phase.',
      WRONG_CALCULATION_METHODOLOGY_FORMULA: 'Die Methode hat eine falsche Berechnungsformel.',
      AI_INTEGRATION_UNEXPECTED_FINISH_REASON: 'Unerwarteter Abschlussgrund bei KI-Diensten.',
      AI_INTEGRATION_NO_CONTENT: 'Fehlender Inhalt in der KI-Integration.',
      WRONG_RESOURCES_FOR_ESTIMATION_ITEM: 'Falsche Ressourcen für die Phase.',
      WRONG_RESOURCE_TYPE_COSTS_FOR_ESTIMATION: 'Falsche Ressourcentypkosten für die Schätzung.',
      CANNOT_DEFINE_COSTS_WHEN_THERE_ARE_NO_RESOURCE_TYPES_DEFINED:
        'Kosten können nicht definiert werden, wenn keine Ressourcentypen definiert sind.',
      ESTIMATION_ITEM_FOR_ESTIMATION_MODEL_ITEM_MUST_HAVE_SAME_GROUP_AS_THE_MODEL_ITEM:
        'Eine auf einem Modell basierende Phase muss dieselbe Gruppe wie die Modellphasendefinition haben.',
      WRONG_ESTIMATION_MODEL_GROUP_ID: 'Falsche Schätzmodellgruppe.',
      UNAUTHORIZED_USER_ACCESS: 'Unbefugter Benutzerzugriff.',
      USER_PROVISIONING_MISSING_EMAIL_CLAIM:
        'Es tut uns leid, aber Ihr Login enthält keine E-Mail-Adresse. Bitte wenden Sie sich an Ihren Administrator.',
      ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_COMBINATION_OF_PARENT_ID_ORDER_AND_PURPOSE:
        'Schätzmodell-Phasendefinitionen mit demselben übergeordneten Element dürfen nicht dieselbe Reihenfolge haben.',
      ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_REF_KEY:
        'Schätzmodell-Phasendefinitionen dürfen nicht denselben Ref-Schlüssel haben.',
      ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_CALCULATION_REF:
        'Schätzmodell-Phasendefinitionen dürfen nicht denselben Referenznamen haben.',
      ESTIMATION_MODEL_WITH_SAME_PROJECT_TYPE_BUT_DIFFERENT_REF_KEY_EXISTS:
        'Ein Schätzmodell mit demselben Projekttyp, aber anderem Ref-Schlüssel existiert bereits.',
      ESTIMATION_MUST_BE_APPROVED_WHEN_CREATING_NEW_VERSION:
        'Die Schätzung muss abgeschlossen sein, um eine neue Version zu erstellen.',
      CALCULATION_FORMULA_MUST_BE_PROVIDED_WHEN_HAVING_MULTIPLE_PARAMETERS:
        'Eine Berechnungsformel muss angegeben werden, wenn mehrere Parameter definiert sind.',
      TENANT_NOT_AVAILABLE: 'Der Mandant ist nicht verfügbar.',
      GRAPH_API_EMPTY_USER_RESULT: 'Die Graph-API hat einen leeren Benutzer zurückgegeben.',
      CANNOT_PARSE_GRAPH_API_USER_ID: 'Die Graph-API-Benutzer-ID kann nicht analysiert werden.',
      CANNOT_CHANGE_ESTIMATION_ITEM_METHODOLOGY_ON_CHILD_ITEM:
        'Die Methode des Schätzitems kann bei einem Unteritem nicht geändert werden.',
      CANNOT_CREATE_INITIAL_ESTIMATION_ITEMS_WHEN_ANY_ITEMS_ALREADY_EXIST:
        'Es können keine initialen Schätzitems erstellt werden, wenn bereits Items existieren.',
      ESTIMATION_ITEM_PARAMETER_CREATION_FAILED:
        'Die Erstellung eines Schätzitem-Parameters ist fehlgeschlagen.',
      PUBLISHED_ESTIMATION_MODEL_CANNOT_BE_UNPUBLISHED:
        'Das Schätzmodell, das bereits veröffentlicht wurde, kann nicht zurückgezogen werden.',
      DUPLICATE_METHODOLOGY_ID_IN_ESTIMATION_MODEL: 'Doppelte Methode-ID im Schätzmodell.',
      ESTIMATION_MODEL_UNIT_MISMATCH: 'Einheiten müssen mit dem Schätzmodell übereinstimmen.',
      DUPLICATE_ESTIMATION_UNIT_IN_ESTIMATION_MODEL: 'Doppelte Schätzeinheit im Schätzmodell.',
      ESTIMATION_MODEL_ADDITIONAL_FIELD_TYPE_MUST_BE_SELECTABLE:
        'Der Stammdaten des Schätzmodells muss auswählbar sein.',
      ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTIONS_MUST_NOT_BE_EMPTY:
        'Die Stammdatenoptionen des Schätzmodells dürfen nicht leer sein.',
      SELF_REFERENCING_PARENT_ERROR: 'Selbstreferenzierender Elternteil.',
      CALCULATION_FORMULA_MISSING: 'Berechnungsformel fehlt.',
      INVALID_CALCULATION_REFERENCE: 'Ungültige Berechnungsreferenz.',
      FILTER_COMBINATION_IS_NOT_SUPPORTED: 'Die Filterkombination wird nicht unterstützt.',
      PARENT_AND_CHILD_COMMENT_DISCRIMINATOR_TYPE_MISMATCH: 'Ungleichheit im Kommentartyp.',
      ESTIMATION_ITEM_PARAMETER_VALUES_COUNT_MISMATCH:
        'Die Anzahl der Parameterwerte des Schätzungselements stimmt nicht überein.',
      ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTION_MUST_NOT_CONTAIN_PIPE:
        'Eine auswählbare Option darf das Zeichen "|" nicht enthalten.',
      ESTIMATION_ITEM_COST_NOT_FOUND: 'Phasenkosten nicht gefunden.',
      WRONG_COSTS_FOR_ESTIMATION_ITEM: 'Falsche Kosten für das Schätzelement.',
      ESTIMATION_MODEL_ITEM_HAS_RECURSIVE_FORMULA_REFERENCE:
        'Das Schätzmodellelement hat eine rekursive Formelbeziehung.',
      ESTIMATION_MODEL_ITEM_HAS_WRONG_FORMULA_REFERENCE:
        'Das Schätzmodellelement hat eine falsche Formelbeziehung.',
      ESTIMATION_MODEL_ITEM_HAS_MISSING_FORMULA_PARAMETERS:
        'Dem Schätzmodellelement fehlen Formeldaten.',
      DECIMAL_VALUE_TOO_MANY_DIGITS: 'Der Dezimalwert hat zu viele Ziffern.',
      DECIMAL_VALUE_TOO_MANY_DECIMAL_DIGITS: 'Der Dezimalwert hat zu viele Nachkommastellen.',
      CANNOT_SET_PARAMETERS_ON_ITEM_WITH_COST_PURPOSE:
        'Parameter können für ein Element mit Kostenfunktion nicht festgelegt werden.',
      ESTIMATION_ITEM_PURPOSE_MUST_MATCH_ITS_ESTIMATION_MODEL_ITEM_PURPOSE:
        'Der Zweck des Schätzungselements muss mit dem Zweck des entsprechenden Schätzmodellelements übereinstimmen.',
      CANNOT_SET_METHODOLOGY_ON_ITEM_WITH_COST_PURPOSE:
        'Die Methode kann für ein Schätzselement mit Kostenfunktion nicht festgelegt werden.',
      ESTIMATION_ITEM_OF_COST_PURPOSE_CANNOT_HAVE_CALCULATED_RESULT:
        'Ein Schätzelement mit Kostenfunktion kann kein berechnetes Ergebnis haben.',
      PARENT_ESTIMATION_ITEM_PURPOSE_MUST_MATCH:
        'Der Zweck des übergeordneten Schätzelements muss übereinstimmen.',
      ESTIMATION_MODEL_ITEM_PARENT_PURPOSE_MUST_MATCH:
        'Der Zweck des übergeordneten Schätzmodellelements muss übereinstimmen.',
      CANNOT_SET_METHODOLOGY_ON_ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE:
        'Die Methode kann nicht für ein Schätzmodellelement mit Kostenfunktion festgelegt werden.',
      ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_CALCULATION_FORMULA:
        'Ein Schätzmodellelement mit Kostenfunktion kann keine Berechnungsformel haben.',
      ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_PARAMETERS:
        'Ein Schätzmodellelement mit Kostenfunktion kann keine Parameter haben.',
      CANNOT_ASSIGN_RESOURCE_TO_ESTIMATION_ITEM_WITH_COST_PURPOSE:
        'Ressource kann nicht einem Schätzelement mit Kostenverwendung zugewiesen werden.',
      CALCULATED_ESTIMATION_MODEL_ITEM_CANNOT_HAVE_PARAMETER_WITH_NULL_VALUE:
        'Berechnetes Schätzmodellelement kann keinen Parameter mit leerem Wert haben.',
      ESTIMATION_STAGE_MUST_BE_IN_REVIEW_WHEN_CHANGING_TO_APPROVED_STAGE:
        'Die Schätzphase muss in Überprüfung sein, um in die genehmigte Phase überzugehen.',
      ESTIMATION_STAGE_MUST_BE_IN_PROCESS_WHEN_CHANGING_TO_IN_REVIEW_STAGE:
        'Die Schätzphase muss im Prozess sein, um in die Überprüfungsphase überzugehen.',
      ESTIMATION_STAGE_MUST_BE_IN_CREATION_OR_IN_REVIEW_WHEN_CHANGING_TO_IN_PROCESS_STAGE:
        'Die Schätzphase muss in Erstellung oder Überprüfung sein, um in die Prozessphase überzugehen.',
      CANNOT_UPDATE_ESTIMATION_WHEN_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzung kann nicht aktualisiert werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_UPDATE_ESTIMATION_ADDITIONAL_FIELDS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzstammdatenfelder können nicht aktualisiert werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_UPSERT_ESTIMATION_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzkosten können nicht aktualisiert werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_CREATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzelemente können nicht erstellt werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_UPSERT_ESTIMATION_ITEMS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzelemente können nicht aktualisiert werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_UPDATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzelemente können nicht aktualisiert werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_DELETE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzelemente können nicht gelöscht werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_CREATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzannahmen können nicht erstellt werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_UPDATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzannahmen können nicht aktualisiert werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_DELETE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzannahmen können nicht gelöscht werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_UPSERT_ESTIMATION_ITEM_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzkosten können nicht aktualisiert werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_UPSERT_ESTIMATION_ITEM_RESOURCES_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED:
        'Schätzressourcen können nicht aktualisiert werden, wenn die Phase in Überprüfung oder genehmigt ist.',
      CANNOT_DELETE_ESTIMATION_ITEM_WITH_ESTIMATION_MODEL_ITEM:
        'Schätzelement mit Schätzmodellelement kann nicht gelöscht werden.',
      CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DATE: 'Datumsformat der Stammdaten ist falsch.',
      CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DOCUMENT_LINK:
        'Der Dokumentenlink muss eine gültige URL sein.',
      CANNOT_COMMENT_WHEN_ESTIMATION_IS_NOT_IN_REVIEW:
        'Kommentar nur während der Überprüfung möglich.',
      THERE_MUST_BE_EXACTLY_ONE_PLANNING_RESPONSIBLE_FOR_ESTIMATION:
        'Für jede Schätzung muss genau eine verantwortliche Person für die Planung festgelegt sein.',
      CANNOT_DELETE_USER_WHEN_IS_PLANNING_RESPONSIBLE:
        'Der Benutzer ist für die Planung der Schätzung(en) verantwortlich und kann daher nicht gelöscht werden.',
      ESTIMATION_MODEL_ITEM_REFERENCES_NON_EXISTING_ITEM:
        'Das Schätzungsmodell-Element verweist in seiner Formel auf ein nicht vorhandenes Element. Bitte überprüfen Sie die Formeln und Referenznamen.',
      EVERY_PHASE_LEAD_MUST_BE_ASSIGNED_AS_CONTRIBUTOR_OR_PLANNING_RESPONSIBLE_TO_ESTIMATION:
        'Jede Phasenleitung muss als Planungsmitarbeiter oder Planungsverantwortlicher der Schätzung zugewiesen werden.',
    },
  },
  global: {
    appName: 'Estimator',
    initializatingSystem: 'System wird initialisiert, bitte warten',
    signInFailed:
      'Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.',
    signInRetry: 'Erneut versuchen',
    provisioningBlocked:
      'Ihr Konto konnte nicht eingerichtet werden, da bei Ihrer Anmeldung erforderliche Angaben fehlen. Bitte wenden Sie sich mit der untenstehenden Referenz an Ihren Administrator oder den Support.',
    resetPasswordOrResendInvite:
      'Passwort zurücksetzen / Administrator bitten, die Einladung erneut zu senden',
    signOut: 'Abmelden',
    continueEstimationOf: 'Schätzung fortsetzen',
    continueEstimation: 'Schätzung fortsetzen',
    saveAllChanges: 'Alle Änderungen speichern',
    saveAndClose: 'Speichern und schließen',
    save: 'Speichern',
    create: 'Erstellen',
    close: 'Schließen',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    confirm: 'Bestätigen',
    copy: 'Kopieren',
    publish: 'Veröffentlichen',
    paginationText: '`Zeigt {from} bis {to} von {totalCount} Einträgen`',
    loading: 'Lädt...',
    saving: 'Speichern...',
    NoDataFound: 'Keine Daten gefunden',
    NoTenantsFound: 'Keine Mandanten gefunden',
    search: 'Suche...',
    status: 'Status',
    noOfUsers: 'Anzahl der Benutzer',
    createdAt: 'Erstellt am',
    yes: 'Ja',
    no: 'Nein',
    prevStep: 'Vorheriger Schritt',
    nextStep: 'Nächster Schritt',
    export: 'Export',
    notAvailable: 'N/A',
    areYouSureYouWantToProceed: 'Sind Sie sicher, dass Sie fortfahren möchten?',
    columns: 'Spalten',
    selectLanguage: 'Sprache auswählen',
    unexpectedError:
      'Ein unerwarteter Fehler ist aufgetreten. Bitte wenden Sie sich an den Support.',
    chooseDate: 'Datum auswählen',
    savedSuccessfully: 'Änderungen erfolgreich gespeichert.',
    emptyContext: 'Keine Daten gefunden, wird zum ersten Schritt des Assistenten weitergeleitet.',
    tenantStylesNotLoaded: 'Tenant styles failed to load.',
    inactive: 'INACTIVE',
    next: 'Nächster',
    finish: 'Fertig',
    back: 'Zurück',
    filter: 'Filter',
    applyFilters: 'Filter anwenden',
    select: 'Auswählen...',
    estimation: 'Schätzung',
  },
  table: {
    pagination: {
      message: 'Zeigt {from} bis {to} von {totalRecords} Einträgen',
    },
  },
  estimationTemplate: {
    duplicateReferenceName: 'Referenzname muss eindeutig sein',
  },
  estimation: {
    detail: {
      managementReport: {
        basicProjectData: 'Grundlegende Projektdaten',
        fields: 'Felder',
        resourceCostBreakdownSummary: 'Zusammenfassung der Ressourcenkostenaufschlüsselung',
        resourceCostBreakdownDetail: 'Ressourcenkostenaufschlüsselung (Detail)',
        resourceCostBreakdownSummaryTable: {
          emptyTableText: 'Keine Ressourcenkostenelemente anzuzeigen',
          projectPhase: 'Projektphase',
        },
        summaryTable: {
          subtotal: 'Gesamtsumme',
          emptyTableText: 'Keine Daten verfügbar',
          projectPhase: 'Projektphase',
          reference: 'Referenz',
          estimate: 'Schätzung',
          assumptions: 'Annahmen',
          totalEfforts: 'Gesamtaufwand',
          directCostItem: 'Direktkostenelement',
          total: 'Gesamt',
          noAssumptions: 'Keine Annahmen',
          noDirectCostItems: 'Keine Direktkostenelemente anzuzeigen',
          comments: 'Kommentare',
        },
      },
    },
  },
  notificationSettings: {
    header: 'Benachrichtigungseinstellungen',
    description:
      'Konfigurieren Sie, wie Benutzer Benachrichtigungen für Workflow-Ereignisse erhalten. Die Einstellungen gelten mandantenweit pro Rolle.',
    loading: 'Benachrichtigungseinstellungen werden geladen...',
    saveSuccess: 'Benachrichtigungseinstellungen erfolgreich gespeichert.',
    saveError: 'Fehler beim Speichern der Benachrichtigungseinstellungen.',
    workflowEvent: 'Workflow-Ereignis',
    role: 'Rolle',
    deliveryMode: 'Übermittlungsmodus',
    contributor: 'Planungsmitarbeiter',
    planningResponsible: 'Planungsverantwortlicher',
    reviewer: 'Reviewer',
    none: 'Keine',
    inApp: 'In-App',
    email: 'E-Mail',
    both: 'Beide',
    userAssignedAsContributor: 'Benutzer als Planungsmitarbeiter zugewiesen',
    userAssignedAsPlanningResponsible: 'Benutzer als Planungsverantwortlicher zugewiesen',
    userAssignedAsReviewer: 'Benutzer als Reviewer zugewiesen',
    estimationReviewRequested: 'Schätzung zur Überprüfung eingereicht',
    estimationReviewCancelled: 'Überprüfung abgebrochen',
    estimationApproved: 'Schätzung genehmigt',
    estimationNewVersionCreated: 'Neue Version erstellt',
    estimationAiReviewCreated: 'KI-Bewertung erstellt',
    userAssignedAsPhaseLead: 'Benutzer als Phasenleiter zugewiesen',
    commentAddedToEstimationItem: 'Kommentar zum Schätzobjekt hinzugefügt',
    reviewCommentsSummaryAvailable: 'Zusammenfassung der Review-Kommentare verfügbar',
    estimationReviewOutcome: 'Schätzungsüberprüfung: Ergebnis',
    phaseStatusChanged: 'Phasenstatus geändert',
    phaseBlocked: 'Phase blockiert',
    phaseUnblocked: 'Phasenblockierung aufgehoben',
    itemAssignedToPhase: 'Objekt der Phase zugewiesen',
    phaseDeadlineApproaching: 'Phasenfrist rückt näher',
    conversationShared: 'AI Advisory Unterhaltung geteilt',
  },
};
